import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";

/**
 * @tencent/vft-atom
 * 
 * @version 1.9.1
 * @author colynchen
 * (c) Tencent VFT.
 */
import "@tencent/vft-atom/lib/tenvideo";
var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {};
var t = "undefined" != typeof __VUE_SSR_CONTEXT__ ? __VUE_SSR_CONTEXT__ : e;

function n() {
  var e;
  return (null == t || null == (e = t.navigator) ? void 0 : e.userAgent) || "";
}

null == e || e.document;
var o = {};

function r(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function i(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

!function (t) {
  t || (t = n());

  var r = "undefined" != typeof __VUE_SSR_CONTEXT__,
      i = t.indexOf("iPhone") >= 0,
      a = /(iPad).*OS\s([\d_]+)/.test(t),
      s = i || a,
      c = t.indexOf("Android") >= 0,
      u = c && t.indexOf("Mobile") < 0,
      l = t.indexOf("Macintosh") >= 0,
      p = t.indexOf("Windows") >= 0,
      f = /QQ\/([\d.]+)/.test(t),
      d = t.indexOf("MicroMessenger") >= 0 && t.indexOf("wxwork") < 0,
      h = !r && t.indexOf("MicroMessenger") >= 0 && ("miniprogram" === e.__wxjs_environment || t.match(/miniprogram/i)),
      v = "undefined" != typeof wx && wx.request || h,
      g = /(QQLive|WeTV)(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/i.test(t),
      m = t.indexOf("QQLiveKidBrowser") >= 0,
      y = g && t.indexOf("WeTVBrowser") >= 0,
      w = /WEISHI_(\d+(\.\d+)*)/i.test(t) || t.indexOf("ilive") > -1,
      b = g && t.indexOf("QQLiteBrowser") >= 0,
      _ = t.indexOf("QQLiveBrowser") >= 0 && !b,
      O = g && "undefined" != typeof location && !/^http(s)?:/.test(location.protocol),
      x = t.indexOf("QQLiveHDBrowser") >= 0 || _ && t.indexOf("AppType/HD") >= 0,
      E = _ && a && (t.indexOf("iPhone") >= 0 || t.indexOf("AppType/UN") >= 0),
      S = t.indexOf("TenvideoUnion") > -1,
      k = /\sSogouMSE\/(\d[\\.\d]*)/i.test(t),
      A = !r && (e.qb_bridge || !(!e.mtt || !e.mtt.getBrowserParam) || /MttVideo/i.test(t)),
      T = !k && (s ? /mqqbrowser\/(\d+(\.\d+){2,})/gi.test(t) : A),
      I = /qqnews\/(\d+(\.\d+)*)/i.test(t),
      L = /QQLive\/\d+/.test(t),
      j = /qqsports/i.test(t),
      C = /\bQQMUSIC\/(\d[\\.\d]*)/i.test(t) || /QQMUSIC\/(\d[\\.\d]*)/i.test(t),
      P = /MSDK\/(\d[\\.\d]*)[a-z]?/.test(t),
      q = /QQAC_CLIENT/i.test(t),
      R = /lolapp/i.test(t),
      M = /smobagamehelper/.test(t);

  Object.assign(o, {
    isIos: s,
    isIphone: i,
    isIpad: a,
    isUNApp: E,
    isHDApp: x,
    isAndroid: c,
    isApad: u,
    isMac: l,
    isWin: p,
    isMqq: f,
    isWechat: d,
    isApp: g,
    isKidApp: m,
    isWetv: y,
    isMqb: T,
    isPCClient: L,
    isWeb: !(i || c || a || u || /(WebOS|BlackBerry)/.test(t)),
    os: "other",
    app: "browser",
    device: "unknown",
    isLiteApp: b,
    isBaseApp: _,
    isLocalPkg: O,
    isWeishi: w,
    isWeChatMiniProgram: v,
    isTenvideoUnion: S,
    isQQNews: I,
    isQQSports: j,
    isQQMusic: C,
    isMsdk: P,
    isAccomic: q,
    isMlol: R,
    isSogouMse: k,
    isMobaCamps: M,
    isCSR: r,
    inBrowser: "undefined" != typeof window,
    isHoneWeb: "undefined" != typeof HoneWeb
  }), o.isIos ? o.os = "ios" : o.isAndroid ? o.os = "android" : p ? o.os = "windows" : l && (o.os = "mac"), m ? o.app = "kidapp" : b ? o.app = "liteapp" : g ? o.app = "app" : d ? o.app = "wechat" : f ? o.app = "mqq" : T ? o.app = "qqbrowser" : w ? o.app = "weishi" : I ? o.app = "qqnews" : j ? o.app = "qqsports" : C ? o.app = "qqmusic" : q ? o.app = "accomic" : R ? o.app = "mlol" : k ? o.app = "sogoumse" : M && (o.app = "wzyd"), a ? o.device = "ipad" : i ? o.device = "iphone" : u ? o.device = "apad" : c ? o.device = "aphone" : l ? o.device = "mac" : p && (o.device = "windows");
  var N = (t.match({
    ios: /OS (.*?) like Mac OS/,
    android: /Android (.*?);/i,
    windows: /Windows NT (.*?);/i,
    mac: /\(Macintosh; Intel Mac OS X (.*?)\)/
  }[o.os] || "") || ["", ""])[1];
  o.osVersion = N ? N.replace(/_/g, ".") : "";
  var B = (t.match({
    app: /(?:QQLive|WeTV)(?:HD|Kid)?(?:Browser|_MAC)\/(\d[\\.\d]*)/,
    kidapp: /QQLiveKidBrowser\/(\d[\\.\d]*)/,
    weishi: /WEISHI_(\d[\\.\d]*)/i,
    mqq: /QQ\/(\d[\\.\d]*)/i,
    wechat: /MicroMessenger\/(\d[\\.\d]*)/i,
    qqbrowser: /MQQBrowser\/(\d[\\.\d]*)/i,
    qqnews: /qqnews\/(\d[\\.\d]*)/i,
    qqsports: /(?:com\.tencent\.sportskbs|qqsports_android_ver)\/(\d[\\.\d]*)/i,
    qqmusic: /\sQQMusic\/(\d[\\.\d]*)/i,
    sogoumse: /\sSogouMSE\/(\d[\\.\d]*)/i
  }[o.app] || "") || ["", ""])[1];
  o.appVersion = B ? B.replace(/_/g, ".") : "";
}();
var a = i(function (e) {
  function t(n, o) {
    return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n, o);
  }

  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
});
r(a);
var s = r(i(function (e) {
  e.exports = function (e, t) {
    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, a(e, t);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
})),
    c = r(i(function (e) {
  function t(e, t, n, o, r, i, a) {
    try {
      var s = e[i](a),
          c = s.value;
    } catch (e) {
      return void n(e);
    }

    s.done ? t(c) : Promise.resolve(c).then(o, r);
  }

  e.exports = function (e) {
    return function () {
      var n = this,
          o = arguments;
      return new Promise(function (r, i) {
        var a = e.apply(n, o);

        function s(e) {
          t(a, r, i, s, c, "next", e);
        }

        function c(e) {
          t(a, r, i, s, c, "throw", e);
        }

        s(void 0);
      });
    };
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
})),
    u = i(function (e) {
  function t(n) {
    return e.exports = t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }

  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
});
r(u);
var l = i(function (e) {
  var t = u.default;

  function n() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    e.exports = n = function n() {
      return o;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
    var o = {},
        r = Object.prototype,
        i = r.hasOwnProperty,
        a = "function" == typeof Symbol ? Symbol : {},
        s = a.iterator || "@@iterator",
        c = a.asyncIterator || "@@asyncIterator",
        u = a.toStringTag || "@@toStringTag";

    function l(e, t, n) {
      return Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }

    try {
      l({}, "");
    } catch (e) {
      l = function l(e, t, n) {
        return e[t] = n;
      };
    }

    function p(e, t, n, o) {
      var r = t && t.prototype instanceof h ? t : h,
          i = Object.create(r.prototype),
          a = new k(o || []);
      return i._invoke = function (e, t, n) {
        var o = "suspendedStart";
        return function (r, i) {
          if ("executing" === o) throw new Error("Generator is already running");

          if ("completed" === o) {
            if ("throw" === r) throw i;
            return T();
          }

          for (n.method = r, n.arg = i;;) {
            var a = n.delegate;

            if (a) {
              var s = x(a, n);

              if (s) {
                if (s === d) continue;
                return s;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if ("suspendedStart" === o) throw o = "completed", n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = "executing";
            var c = f(e, t, n);

            if ("normal" === c.type) {
              if (o = n.done ? "completed" : "suspendedYield", c.arg === d) continue;
              return {
                value: c.arg,
                done: n.done
              };
            }

            "throw" === c.type && (o = "completed", n.method = "throw", n.arg = c.arg);
          }
        };
      }(e, n, a), i;
    }

    function f(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    o.wrap = p;
    var d = {};

    function h() {}

    function v() {}

    function g() {}

    var m = {};
    l(m, s, function () {
      return this;
    });
    var y = Object.getPrototypeOf,
        w = y && y(y(A([])));
    w && w !== r && i.call(w, s) && (m = w);
    var b = g.prototype = h.prototype = Object.create(m);

    function _(e) {
      ["next", "throw", "return"].forEach(function (t) {
        l(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }

    function O(e, n) {
      var o;

      this._invoke = function (r, a) {
        function s() {
          return new n(function (o, s) {
            !function o(r, a, s, c) {
              var u = f(e[r], e, a);

              if ("throw" !== u.type) {
                var l = u.arg,
                    p = l.value;
                return p && "object" == t(p) && i.call(p, "__await") ? n.resolve(p.__await).then(function (e) {
                  o("next", e, s, c);
                }, function (e) {
                  o("throw", e, s, c);
                }) : n.resolve(p).then(function (e) {
                  l.value = e, s(l);
                }, function (e) {
                  return o("throw", e, s, c);
                });
              }

              c(u.arg);
            }(r, a, o, s);
          });
        }

        return o = o ? o.then(s, s) : s();
      };
    }

    function x(e, t) {
      var n = e.iterator[t.method];

      if (void 0 === n) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method)) return d;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return d;
      }

      var o = f(n, e.iterator, t.arg);
      if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, d;
      var r = o.arg;
      return r ? r.done ? (t[e.resultName] = r.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : r : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
    }

    function E(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function S(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function k(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(E, this), this.reset(!0);
    }

    function A(e) {
      if (e) {
        var t = e[s];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var n = -1,
              o = function t() {
            for (; ++n < e.length;) {
              if (i.call(e, n)) return t.value = e[n], t.done = !1, t;
            }

            return t.value = void 0, t.done = !0, t;
          };

          return o.next = o;
        }
      }

      return {
        next: T
      };
    }

    function T() {
      return {
        value: void 0,
        done: !0
      };
    }

    return v.prototype = g, l(b, "constructor", g), l(g, "constructor", v), v.displayName = l(g, u, "GeneratorFunction"), o.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
    }, o.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(b), e;
    }, o.awrap = function (e) {
      return {
        __await: e
      };
    }, _(O.prototype), l(O.prototype, c, function () {
      return this;
    }), o.AsyncIterator = O, o.async = function (e, t, n, r, i) {
      void 0 === i && (i = Promise);
      var a = new O(p(e, t, n, r), i);
      return o.isGeneratorFunction(t) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, _(b), l(b, u, "Generator"), l(b, s, function () {
      return this;
    }), l(b, "toString", function () {
      return "[object Generator]";
    }), o.keys = function (e) {
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return t.reverse(), function n() {
        for (; t.length;) {
          var o = t.pop();
          if (o in e) return n.value = o, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, o.values = A, k.prototype = {
      constructor: k,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for (var t in this) {
          "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var t = this;

        function n(n, o) {
          return a.type = "throw", a.arg = e, t.next = n, o && (t.method = "next", t.arg = void 0), !!o;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var r = this.tryEntries[o],
              a = r.completion;
          if ("root" === r.tryLoc) return n("end");

          if (r.tryLoc <= this.prev) {
            var s = i.call(r, "catchLoc"),
                c = i.call(r, "finallyLoc");

            if (s && c) {
              if (this.prev < r.catchLoc) return n(r.catchLoc, !0);
              if (this.prev < r.finallyLoc) return n(r.finallyLoc);
            } else if (s) {
              if (this.prev < r.catchLoc) return n(r.catchLoc, !0);
            } else {
              if (!c) throw new Error("try statement without catch or finally");
              if (this.prev < r.finallyLoc) return n(r.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var o = this.tryEntries[n];

          if (o.tryLoc <= this.prev && i.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var r = o;
            break;
          }
        }

        r && ("break" === e || "continue" === e) && r.tryLoc <= t && t <= r.finallyLoc && (r = null);
        var a = r ? r.completion : {};
        return a.type = e, a.arg = t, r ? (this.method = "next", this.next = r.finallyLoc, d) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), d;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), S(n), d;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];

          if (n.tryLoc === e) {
            var o = n.completion;

            if ("throw" === o.type) {
              var r = o.arg;
              S(n);
            }

            return r;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, t, n) {
        return this.delegate = {
          iterator: A(e),
          resultName: t,
          nextLoc: n
        }, "next" === this.method && (this.arg = void 0), d;
      }
    }, o;
  }

  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
});
r(l);
var p = l(),
    f = p;

try {
  regeneratorRuntime = p;
} catch (e) {
  "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = p : Function("r", "regeneratorRuntime = r")(p);
}

var d = function () {
  function e(e) {
    this._target = e, this._proxyEnabled = !1, this._cookies = {};
  }

  var t = e.prototype;
  return t.get = function (e) {
    var t;
    if (!0 === this._proxyEnabled) return "object" == _typeof(this._cookies) && this._cookies[e] || "";

    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
      o[r - 1] = arguments[r];
    }

    return (t = this._target).get.apply(t, [e].concat(o));
  }, t.set = function () {
    var e;
    return (e = this._target).set.apply(e, arguments);
  }, t.remove = function () {
    var e;
    return (e = this._target).remove.apply(e, arguments);
  }, t.setCookies = function (e) {
    void 0 === e && (e = {}), this._cookies = e;
  }, t.getCookies = function () {
    return this._cookies;
  }, t.enableProxy = function () {
    this._proxyEnabled = !0;
  }, t.disableProxy = function () {
    this._proxyEnabled = !1;
  }, t.isProxyEnabled = function () {
    return this._proxyEnabled;
  }, e;
}(),
    h = function h(e, t) {
  var n = [].concat(e);
  return t.name && n.unshift("[" + t.name + "]"), n;
},
    v = function () {
  function e(t, n) {
    var o = this,
        r = void 0 === n ? {} : n,
        i = r.level,
        a = r.formatter;
    this.name = t, this.formatter = a || h, this.setLevel(i), e.LOG_METHODS.forEach(function (e) {
      o[e] = function () {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
          n[r] = arguments[r];
        }

        o.invoke(e, n);
      };
    });
  }

  var t = e.prototype;
  return t.invoke = function (t, n) {
    if (!(this.level > e.LEVELS[t])) try {
      var o;
      (o = console)[t].apply(o, this.formatter(n, this));
    } catch (e) {
      console.error("[logger] Failed to print logger." + t + " because of: ", e);
    }
  }, t.setLevel = function (t) {
    if ("number" == typeof t) this.level = t;else try {
      this.level = e.LEVELS[e.LOG_METHODS[e.LOG_METHODS.length - 2]];
    } catch (t) {
      this.level = e.LEVELS[e.LOG_METHODS[0]], console.error("[logger] Set default level to 0 because of:", t);
    }
  }, t.getLevel = function () {
    return this.level;
  }, e;
}();

v.LOG_METHODS = ["trace", "debug", "info", "warn", "error"], v.LEVELS = {}, v.LOG_METHODS.forEach(function (e, t) {
  v.LEVELS[e] = t;
});

var g = new v("vft-common"),
    m = {},
    y = decodeURIComponent,
    w = encodeURIComponent,
    b = Object.create || function (e) {
  function t() {}

  return t.prototype = e, new t();
};

m.get = function (t, n) {
  var o;
  T(t);
  var r = n ? b(n) : {};
  "function" == typeof n && (r = {
    converter: n
  });
  var i = x((null == (o = e.document) ? void 0 : o.cookie) || "", !r.raw);
  return (r.converter || I)(i[t]);
}, m.set = function (e, t, n) {
  T(e);
  var o = n ? b(n) : {},
      r = o.expires,
      i = o.domain,
      a = o.path;
  o.raw || (t = w(String(t)));
  var s = e + "=" + t,
      c = r;
  return "number" == typeof c && (c = new Date()).setTime(c.getTime() + 1e3 * r), c instanceof Date && (s += "; expires=" + c.toUTCString()), A(i) && (s += "; domain=" + i), A(a) && (s += "; path=" + a), o.secure && (s += "; secure"), document.cookie = s, s;
}, m.remove = function (e, t) {
  var n = t ? b(t) : {};
  return n.expires = new Date(0), this.set(e, "", n);
};

var _ = o.isCSR ? "" : document.cookie,
    O = null;

function x(e, t) {
  if (_ === e && O) return O;
  var n = {};
  if (_ = e, k(e) && e.length > 0) for (var o, r, i, a = t ? y : I, s = e.split(/;\s?/g), c = 0, u = s.length; c < u; c++) {
    if ((i = s[c].match(/([^=]+)=/i)) instanceof Array) try {
      o = y(i[1]), r = a(s[c].substring(i[1].length + 1));
    } catch (e) {} else o = y(s[c]), r = "";
    o && (n[o] = r);
  }
  return O = n, n;
}

function E() {
  return S.apply(this, arguments);
}

function S() {
  return (S = c(f.mark(function t() {
    var n, r, i, a;
    return f.wrap(function (t) {
      for (;;) {
        switch (t.prev = t.next) {
          case 0:
            if (o.isHoneWeb && "undefined" != typeof HoneJSCoreJSBridge) {
              t.next = 2;
              break;
            }

            return t.abrupt("return", (null == (n = e.document) ? void 0 : n.cookie) || "");

          case 2:
            return t.prev = 2, t.next = 5, HoneJSCoreJSBridge.invoke("repost", {
              api: "getAllCookie"
            });

          case 5:
            if (i = t.sent, null != (a = i.data) && a.result) {
              t.next = 9;
              break;
            }

            return t.abrupt("return", "");

          case 9:
            if (null == (r = a.result) || !r.cookie) {
              t.next = 11;
              break;
            }

            return t.abrupt("return", a.result.cookie);

          case 11:
            return t.abrupt("return", Object.keys(a.result).map(function (e) {
              return e + "=" + a.result[e];
            }).join("; "));

          case 14:
            return t.prev = 14, t.t0 = t.catch(2), g.error("HoneJSCoreJSBridge getCookie caught error", t.t0), t.abrupt("return", "");

          case 18:
          case "end":
            return t.stop();
        }
      }
    }, t, null, [[2, 14]]);
  }))).apply(this, arguments);
}

function k(e) {
  return "string" == typeof e;
}

function A(e) {
  return k(e) && "" !== e;
}

function T(e) {
  if (!A(e)) throw new TypeError("Cookie name must be a non-empty string");
}

function I(e) {
  return e || "";
}

var L = new d(m);

var j,
    C = function () {
  function e(e, t) {
    void 0 === e && (e = ""), void 0 === t && (t = {
      size: "small"
    }), "string" != typeof e ? (this.text = "", this.options = e) : (this.text = e, this.options = t), this.createToastDom();
  }

  var t = e.prototype;
  return t.show = function () {
    this.$toast.style.display = "block";
  }, t.hide = function () {
    this.$toast && this.$toast.parentElement && (this.$toast.style.display = "none", this.$toast.parentElement.removeChild(this.$toast));
  }, t.createToastDom = function () {
    var e = this,
        t = document.createElement("div"),
        n = document.createElement("div"),
        o = document.createElement("i"),
        r = this.options.size;

    if (o.innerHTML = '\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block; shape-rendering: auto;" width="35px" height="35px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">\n<g transform="rotate(0 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.875s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(45 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(90 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.625s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(135 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(180 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.375s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(225 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(270 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.125s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(315 50 50)">\n  <rect x="45" y="2.5" rx="5" ry="6.2" width="10" height="31" fill="#ffffff">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animate>\n  </rect>\n</g>\n</svg>\n', t.id = Math.random().toString(36).substr(2), t.className = "__atom_toast__", t.setAttribute("style", "\n  display: block;\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 99999999;\n"), t.ontouchmove = function (e) {
      e.preventDefault();
    }, o.setAttribute("style", "\nbackground: rgba(34,34,34,.85);\nmin-width: 90px;\nheight: 90px;\ndisplay: flex;\npadding: 10px;\nflex-direction: column;\nborder-radius: 10px;\njustify-content: center;\nalign-items: center;\nfont-size: 14px;\nfont-weight: normal;\nmargin-top: -50px;\n"), n.appendChild(o), n.setAttribute("style", "\n  width: 100%;\n  height: 100%;\n  border-radius: 7px;\n  color: #fff;\n  position: absolute;\n  -webkit-display: flex;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"), t.appendChild(n), "" !== this.text) {
      var i = document.createElement("span");
      i.innerText = this.text, i.setAttribute("style", "margin:0;color:#fff;line-height: 1.5;top:-5px;position:relative;"), o.appendChild(i), r = "big";
    }

    "big" === r && (o.style.height = "110px", o.style.minWidth = "110px"), this.options.close && (t.onclick = function () {
      e.hide();
    }), this.options.timeout && setTimeout(this.hide.bind(this), this.options.timeout), document.body.appendChild(t), this.$toast = t;
  }, e;
}(),
    P = r(i(function (e) {
  function t() {
    return e.exports = t = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
  }

  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})),
    q = r(i(function (e) {
  e.exports = function (e, t) {
    if (null == e) return {};
    var n,
        o,
        r = {},
        i = Object.keys(e);

    for (o = 0; o < i.length; o++) {
      n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
    }

    return r;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
})),
    R = function R(e, t) {
  return function () {
    for (var n = new Array(arguments.length), o = 0; o < n.length; o++) {
      n[o] = arguments[o];
    }

    return e.apply(t, n);
  };
},
    M = Object.prototype.toString,
    N = (j = Object.create(null), function (e) {
  var t = M.call(e);
  return j[t] || (j[t] = t.slice(8, -1).toLowerCase());
});

function B(e) {
  return e = e.toLowerCase(), function (t) {
    return N(t) === e;
  };
}

function U(e) {
  return Array.isArray(e);
}

function V(e) {
  return void 0 === e;
}

var D = B("ArrayBuffer");

function Q(e) {
  return null !== e && "object" == _typeof(e);
}

function W(e) {
  if ("object" !== N(e)) return !1;
  var t = Object.getPrototypeOf(e);
  return null === t || t === Object.prototype;
}

var J = B("Date"),
    H = B("File"),
    F = B("Blob"),
    G = B("FileList");

function K(e) {
  return "[object Function]" === M.call(e);
}

var z = B("URLSearchParams");

function X(e, t) {
  if (null != e) if ("object" != _typeof(e) && (e = [e]), U(e)) for (var n = 0, o = e.length; n < o; n++) {
    t.call(null, e[n], n, e);
  } else for (var r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && t.call(null, e[r], r, e);
  }
}

var Y,
    Z = (Y = "undefined" != typeof Uint8Array && Object.getPrototypeOf(Uint8Array), function (e) {
  return Y && e instanceof Y;
}),
    ee = {
  isArray: U,
  isArrayBuffer: D,
  isBuffer: function isBuffer(e) {
    return null !== e && !V(e) && null !== e.constructor && !V(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
  },
  isFormData: function isFormData(e) {
    return e && ("function" == typeof FormData && e instanceof FormData || "[object FormData]" === M.call(e) || K(e.toString) && "[object FormData]" === e.toString());
  },
  isArrayBufferView: function isArrayBufferView(e) {
    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && D(e.buffer);
  },
  isString: function isString(e) {
    return "string" == typeof e;
  },
  isNumber: function isNumber(e) {
    return "number" == typeof e;
  },
  isObject: Q,
  isPlainObject: W,
  isUndefined: V,
  isDate: J,
  isFile: H,
  isBlob: F,
  isFunction: K,
  isStream: function isStream(e) {
    return Q(e) && K(e.pipe);
  },
  isURLSearchParams: z,
  isStandardBrowserEnv: function isStandardBrowserEnv() {
    return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
  },
  forEach: X,
  merge: function e() {
    var t = {};

    function n(n, o) {
      W(t[o]) && W(n) ? t[o] = e(t[o], n) : W(n) ? t[o] = e({}, n) : U(n) ? t[o] = n.slice() : t[o] = n;
    }

    for (var o = 0, r = arguments.length; o < r; o++) {
      X(arguments[o], n);
    }

    return t;
  },
  extend: function extend(e, t, n) {
    return X(t, function (t, o) {
      e[o] = n && "function" == typeof t ? R(t, n) : t;
    }), e;
  },
  trim: function trim(e) {
    return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
  },
  stripBOM: function stripBOM(e) {
    return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
  },
  inherits: function inherits(e, t, n, o) {
    e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, n && Object.assign(e.prototype, n);
  },
  toFlatObject: function toFlatObject(e, t, n) {
    var o,
        r,
        i,
        a = {};
    t = t || {};

    do {
      for (r = (o = Object.getOwnPropertyNames(e)).length; r-- > 0;) {
        a[i = o[r]] || (t[i] = e[i], a[i] = !0);
      }

      e = Object.getPrototypeOf(e);
    } while (e && (!n || n(e, t)) && e !== Object.prototype);

    return t;
  },
  kindOf: N,
  kindOfTest: B,
  endsWith: function endsWith(e, t, n) {
    e = String(e), (void 0 === n || n > e.length) && (n = e.length), n -= t.length;
    var o = e.indexOf(t, n);
    return -1 !== o && o === n;
  },
  toArray: function toArray(e) {
    if (!e) return null;
    var t = e.length;
    if (V(t)) return null;

    for (var n = new Array(t); t-- > 0;) {
      n[t] = e[t];
    }

    return n;
  },
  isTypedArray: Z,
  isFileList: G
};

function te(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}

var ne = function ne(e, t, n) {
  if (!t) return e;
  var o;
  if (n) o = n(t);else if (ee.isURLSearchParams(t)) o = t.toString();else {
    var r = [];
    ee.forEach(t, function (e, t) {
      null != e && (ee.isArray(e) ? t += "[]" : e = [e], ee.forEach(e, function (e) {
        ee.isDate(e) ? e = e.toISOString() : ee.isObject(e) && (e = JSON.stringify(e)), r.push(te(t) + "=" + te(e));
      }));
    }), o = r.join("&");
  }

  if (o) {
    var i = e.indexOf("#");
    -1 !== i && (e = e.slice(0, i)), e += (-1 === e.indexOf("?") ? "?" : "&") + o;
  }

  return e;
};

function oe() {
  this.handlers = [];
}

oe.prototype.use = function (e, t, n) {
  return this.handlers.push({
    fulfilled: e,
    rejected: t,
    synchronous: !!n && n.synchronous,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
}, oe.prototype.eject = function (e) {
  this.handlers[e] && (this.handlers[e] = null);
}, oe.prototype.forEach = function (e) {
  ee.forEach(this.handlers, function (t) {
    null !== t && e(t);
  });
};

var re = oe,
    ie = function ie(e, t) {
  ee.forEach(e, function (n, o) {
    o !== t && o.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[o]);
  });
};

function ae(e, t, n, o, r) {
  Error.call(this), this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), r && (this.response = r);
}

ee.inherits(ae, Error, {
  toJSON: function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var se = ae.prototype,
    ce = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED"].forEach(function (e) {
  ce[e] = {
    value: e
  };
}), Object.defineProperties(ae, ce), Object.defineProperty(se, "isAxiosError", {
  value: !0
}), ae.from = function (e, t, n, o, r, i) {
  var a = Object.create(se);
  return ee.toFlatObject(e, a, function (e) {
    return e !== Error.prototype;
  }), ae.call(a, e.message, t, n, o, r), a.name = e.name, i && Object.assign(a, i), a;
};
var ue = ae,
    le = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
};

var pe = function pe(e, t) {
  t = t || new FormData();
  var n = [];

  function o(e) {
    return null === e ? "" : ee.isDate(e) ? e.toISOString() : ee.isArrayBuffer(e) || ee.isTypedArray(e) ? "function" == typeof Blob ? new Blob([e]) : Buffer.from(e) : e;
  }

  return function e(r, i) {
    if (ee.isPlainObject(r) || ee.isArray(r)) {
      if (-1 !== n.indexOf(r)) throw Error("Circular reference detected in " + i);
      n.push(r), ee.forEach(r, function (n, r) {
        if (!ee.isUndefined(n)) {
          var a,
              s = i ? i + "." + r : r;
          if (n && !i && "object" == _typeof(n)) if (ee.endsWith(r, "{}")) n = JSON.stringify(n);else if (ee.endsWith(r, "[]") && (a = ee.toArray(n))) return void a.forEach(function (e) {
            !ee.isUndefined(e) && t.append(s, o(e));
          });
          e(n, s);
        }
      }), n.pop();
    } else t.append(i, o(r));
  }(e), t;
},
    fe = ee.isStandardBrowserEnv() ? {
  write: function write(e, t, n, o, r, i) {
    var a = [];
    a.push(e + "=" + encodeURIComponent(t)), ee.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), ee.isString(o) && a.push("path=" + o), ee.isString(r) && a.push("domain=" + r), !0 === i && a.push("secure"), document.cookie = a.join("; ");
  },
  read: function read(e) {
    var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
    return t ? decodeURIComponent(t[3]) : null;
  },
  remove: function remove(e) {
    this.write(e, "", Date.now() - 864e5);
  }
} : {
  write: function write() {},
  read: function read() {
    return null;
  },
  remove: function remove() {}
},
    de = function de(e, t) {
  return e && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t) ? function (e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }(e, t) : t;
},
    he = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"],
    ve = ee.isStandardBrowserEnv() ? function () {
  var e,
      t = /(msie|trident)/i.test(navigator.userAgent),
      n = document.createElement("a");

  function o(e) {
    var o = e;
    return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
      href: n.href,
      protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
      host: n.host,
      search: n.search ? n.search.replace(/^\?/, "") : "",
      hash: n.hash ? n.hash.replace(/^#/, "") : "",
      hostname: n.hostname,
      port: n.port,
      pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
    };
  }

  return e = o(window.location.href), function (t) {
    var n = ee.isString(t) ? o(t) : t;
    return n.protocol === e.protocol && n.host === e.host;
  };
}() : function () {
  return !0;
};

function ge(e) {
  ue.call(this, null == e ? "canceled" : e, ue.ERR_CANCELED), this.name = "CanceledError";
}

ee.inherits(ge, ue, {
  __CANCEL__: !0
});

var me = ge,
    ye = function ye(e) {
  return new Promise(function (t, n) {
    var o,
        r = e.data,
        i = e.headers,
        a = e.responseType;

    function s() {
      e.cancelToken && e.cancelToken.unsubscribe(o), e.signal && e.signal.removeEventListener("abort", o);
    }

    ee.isFormData(r) && ee.isStandardBrowserEnv() && delete i["Content-Type"];
    var c = new XMLHttpRequest();

    if (e.auth) {
      var u = e.auth.username || "",
          l = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.Authorization = "Basic " + btoa(u + ":" + l);
    }

    var p = de(e.baseURL, e.url);

    function f() {
      if (c) {
        var o,
            r,
            i,
            u,
            l,
            p = "getAllResponseHeaders" in c ? (o = c.getAllResponseHeaders(), l = {}, o ? (ee.forEach(o.split("\n"), function (e) {
          if (u = e.indexOf(":"), r = ee.trim(e.substr(0, u)).toLowerCase(), i = ee.trim(e.substr(u + 1)), r) {
            if (l[r] && he.indexOf(r) >= 0) return;
            l[r] = "set-cookie" === r ? (l[r] ? l[r] : []).concat([i]) : l[r] ? l[r] + ", " + i : i;
          }
        }), l) : l) : null;
        !function (e, t, n) {
          var o = n.config.validateStatus;
          n.status && o && !o(n.status) ? t(new ue("Request failed with status code " + n.status, [ue.ERR_BAD_REQUEST, ue.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n);
        }(function (e) {
          t(e), s();
        }, function (e) {
          n(e), s();
        }, {
          data: a && "text" !== a && "json" !== a ? c.response : c.responseText,
          status: c.status,
          statusText: c.statusText,
          headers: p,
          config: e,
          request: c
        }), c = null;
      }
    }

    if (c.open(e.method.toUpperCase(), ne(p, e.params, e.paramsSerializer), !0), c.timeout = e.timeout, "onloadend" in c ? c.onloadend = f : c.onreadystatechange = function () {
      c && 4 === c.readyState && (0 !== c.status || c.responseURL && 0 === c.responseURL.indexOf("file:")) && setTimeout(f);
    }, c.onabort = function () {
      c && (n(new ue("Request aborted", ue.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function () {
      n(new ue("Network Error", ue.ERR_NETWORK, e, c, c)), c = null;
    }, c.ontimeout = function () {
      var t = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded",
          o = e.transitional || le;
      e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(new ue(t, o.clarifyTimeoutError ? ue.ETIMEDOUT : ue.ECONNABORTED, e, c)), c = null;
    }, ee.isStandardBrowserEnv()) {
      var d = (e.withCredentials || ve(p)) && e.xsrfCookieName ? fe.read(e.xsrfCookieName) : void 0;
      d && (i[e.xsrfHeaderName] = d);
    }

    "setRequestHeader" in c && ee.forEach(i, function (e, t) {
      void 0 === r && "content-type" === t.toLowerCase() ? delete i[t] : c.setRequestHeader(t, e);
    }), ee.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), a && "json" !== a && (c.responseType = e.responseType), "function" == typeof e.onDownloadProgress && c.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && c.upload && c.upload.addEventListener("progress", e.onUploadProgress), (e.cancelToken || e.signal) && (o = function o(e) {
      c && (n(!e || e && e.type ? new me() : e), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(o), e.signal && (e.signal.aborted ? o() : e.signal.addEventListener("abort", o))), r || (r = null);
    var h,
        v = (h = /^([-+\w]{1,25})(:?\/\/|:)/.exec(p)) && h[1] || "";
    v && -1 === ["http", "https", "file"].indexOf(v) ? n(new ue("Unsupported protocol " + v + ":", ue.ERR_BAD_REQUEST, e)) : c.send(r);
  });
},
    we = {
  "Content-Type": "application/x-www-form-urlencoded"
};

function be(e, t) {
  !ee.isUndefined(e) && ee.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}

var _e,
    Oe = {
  transitional: le,
  adapter: (("undefined" != typeof XMLHttpRequest || "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process)) && (_e = ye), _e),
  transformRequest: [function (e, t) {
    if (ie(t, "Accept"), ie(t, "Content-Type"), ee.isFormData(e) || ee.isArrayBuffer(e) || ee.isBuffer(e) || ee.isStream(e) || ee.isFile(e) || ee.isBlob(e)) return e;
    if (ee.isArrayBufferView(e)) return e.buffer;
    if (ee.isURLSearchParams(e)) return be(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var n,
        o = ee.isObject(e),
        r = t && t["Content-Type"];

    if ((n = ee.isFileList(e)) || o && "multipart/form-data" === r) {
      var i = this.env && this.env.FormData;
      return pe(n ? {
        "files[]": e
      } : e, i && new i());
    }

    return o || "application/json" === r ? (be(t, "application/json"), function (e, t, n) {
      if (ee.isString(e)) try {
        return (t || JSON.parse)(e), ee.trim(e);
      } catch (e) {
        if ("SyntaxError" !== e.name) throw e;
      }
      return (n || JSON.stringify)(e);
    }(e)) : e;
  }],
  transformResponse: [function (e) {
    var t = this.transitional || Oe.transitional,
        n = t && t.silentJSONParsing,
        o = t && t.forcedJSONParsing,
        r = !n && "json" === this.responseType;
    if (r || o && ee.isString(e) && e.length) try {
      return JSON.parse(e);
    } catch (e) {
      if (r) {
        if ("SyntaxError" === e.name) throw ue.from(e, ue.ERR_BAD_RESPONSE, this, null, this.response);
        throw e;
      }
    }
    return e;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: null
  },
  validateStatus: function validateStatus(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};

ee.forEach(["delete", "get", "head"], function (e) {
  Oe.headers[e] = {};
}), ee.forEach(["post", "put", "patch"], function (e) {
  Oe.headers[e] = ee.merge(we);
});

var xe = Oe,
    Ee = function Ee(e, t, n) {
  var o = this || xe;
  return ee.forEach(n, function (n) {
    e = n.call(o, e, t);
  }), e;
},
    Se = function Se(e) {
  return !(!e || !e.__CANCEL__);
};

function ke(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new me();
}

var Ae = function Ae(e) {
  return ke(e), e.headers = e.headers || {}, e.data = Ee.call(e, e.data, e.headers, e.transformRequest), e.headers = ee.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), ee.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
    delete e.headers[t];
  }), (e.adapter || xe.adapter)(e).then(function (t) {
    return ke(e), t.data = Ee.call(e, t.data, t.headers, e.transformResponse), t;
  }, function (t) {
    return Se(t) || (ke(e), t && t.response && (t.response.data = Ee.call(e, t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
  });
},
    Te = function Te(e, t) {
  t = t || {};
  var n = {};

  function o(e, t) {
    return ee.isPlainObject(e) && ee.isPlainObject(t) ? ee.merge(e, t) : ee.isPlainObject(t) ? ee.merge({}, t) : ee.isArray(t) ? t.slice() : t;
  }

  function r(n) {
    return ee.isUndefined(t[n]) ? ee.isUndefined(e[n]) ? void 0 : o(void 0, e[n]) : o(e[n], t[n]);
  }

  function i(e) {
    if (!ee.isUndefined(t[e])) return o(void 0, t[e]);
  }

  function a(n) {
    return ee.isUndefined(t[n]) ? ee.isUndefined(e[n]) ? void 0 : o(void 0, e[n]) : o(void 0, t[n]);
  }

  function s(n) {
    return n in t ? o(e[n], t[n]) : n in e ? o(void 0, e[n]) : void 0;
  }

  var c = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s
  };
  return ee.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
    var t = c[e] || r,
        o = t(e);
    ee.isUndefined(o) && t !== s || (n[e] = o);
  }), n;
},
    Ie = "0.27.2",
    Le = Ie,
    je = {};

["object", "boolean", "number", "function", "string", "symbol"].forEach(function (e, t) {
  je[e] = function (n) {
    return _typeof(n) === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var Ce = {};

je.transitional = function (e, t, n) {
  function o(e, t) {
    return "[Axios v" + Le + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
  }

  return function (n, r, i) {
    if (!1 === e) throw new ue(o(r, " has been removed" + (t ? " in " + t : "")), ue.ERR_DEPRECATED);
    return t && !Ce[r] && (Ce[r] = !0, console.warn(o(r, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, r, i);
  };
};

var Pe = {
  assertOptions: function assertOptions(e, t, n) {
    if ("object" != _typeof(e)) throw new ue("options must be an object", ue.ERR_BAD_OPTION_VALUE);

    for (var o = Object.keys(e), r = o.length; r-- > 0;) {
      var i = o[r],
          a = t[i];

      if (a) {
        var s = e[i],
            c = void 0 === s || a(s, i, e);
        if (!0 !== c) throw new ue("option " + i + " must be " + c, ue.ERR_BAD_OPTION_VALUE);
      } else if (!0 !== n) throw new ue("Unknown option " + i, ue.ERR_BAD_OPTION);
    }
  },
  validators: je
},
    qe = Pe.validators;

function Re(e) {
  this.defaults = e, this.interceptors = {
    request: new re(),
    response: new re()
  };
}

Re.prototype.request = function (e, t) {
  "string" == typeof e ? (t = t || {}).url = e : t = e || {}, (t = Te(this.defaults, t)).method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var n = t.transitional;
  void 0 !== n && Pe.assertOptions(n, {
    silentJSONParsing: qe.transitional(qe.boolean),
    forcedJSONParsing: qe.transitional(qe.boolean),
    clarifyTimeoutError: qe.transitional(qe.boolean)
  }, !1);
  var o = [],
      r = !0;
  this.interceptors.request.forEach(function (e) {
    "function" == typeof e.runWhen && !1 === e.runWhen(t) || (r = r && e.synchronous, o.unshift(e.fulfilled, e.rejected));
  });
  var i,
      a = [];

  if (this.interceptors.response.forEach(function (e) {
    a.push(e.fulfilled, e.rejected);
  }), !r) {
    var s = [Ae, void 0];

    for (Array.prototype.unshift.apply(s, o), s = s.concat(a), i = Promise.resolve(t); s.length;) {
      i = i.then(s.shift(), s.shift());
    }

    return i;
  }

  for (var c = t; o.length;) {
    var u = o.shift(),
        l = o.shift();

    try {
      c = u(c);
    } catch (e) {
      l(e);
      break;
    }
  }

  try {
    i = Ae(c);
  } catch (e) {
    return Promise.reject(e);
  }

  for (; a.length;) {
    i = i.then(a.shift(), a.shift());
  }

  return i;
}, Re.prototype.getUri = function (e) {
  e = Te(this.defaults, e);
  var t = de(e.baseURL, e.url);
  return ne(t, e.params, e.paramsSerializer);
}, ee.forEach(["delete", "get", "head", "options"], function (e) {
  Re.prototype[e] = function (t, n) {
    return this.request(Te(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
}), ee.forEach(["post", "put", "patch"], function (e) {
  function t(t) {
    return function (n, o, r) {
      return this.request(Te(r || {}, {
        method: e,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: o
      }));
    };
  }

  Re.prototype[e] = t(), Re.prototype[e + "Form"] = t(!0);
});
var Me = Re;

function Ne(e) {
  if ("function" != typeof e) throw new TypeError("executor must be a function.");
  var t;
  this.promise = new Promise(function (e) {
    t = e;
  });
  var n = this;
  this.promise.then(function (e) {
    if (n._listeners) {
      var t,
          o = n._listeners.length;

      for (t = 0; t < o; t++) {
        n._listeners[t](e);
      }

      n._listeners = null;
    }
  }), this.promise.then = function (e) {
    var t,
        o = new Promise(function (e) {
      n.subscribe(e), t = e;
    }).then(e);
    return o.cancel = function () {
      n.unsubscribe(t);
    }, o;
  }, e(function (e) {
    n.reason || (n.reason = new me(e), t(n.reason));
  });
}

Ne.prototype.throwIfRequested = function () {
  if (this.reason) throw this.reason;
}, Ne.prototype.subscribe = function (e) {
  this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
}, Ne.prototype.unsubscribe = function (e) {
  if (this._listeners) {
    var t = this._listeners.indexOf(e);

    -1 !== t && this._listeners.splice(t, 1);
  }
}, Ne.source = function () {
  var e;
  return {
    token: new Ne(function (t) {
      e = t;
    }),
    cancel: e
  };
};
var Be = Ne;

var Ue = function e(t) {
  var n = new Me(t),
      o = R(Me.prototype.request, n);
  return ee.extend(o, Me.prototype, n), ee.extend(o, n), o.create = function (n) {
    return e(Te(t, n));
  }, o;
}(xe);

Ue.Axios = Me, Ue.CanceledError = me, Ue.CancelToken = Be, Ue.isCancel = Se, Ue.VERSION = Ie, Ue.toFormData = pe, Ue.AxiosError = ue, Ue.Cancel = Ue.CanceledError, Ue.all = function (e) {
  return Promise.all(e);
}, Ue.spread = function (e) {
  return function (t) {
    return e.apply(null, t);
  };
}, Ue.isAxiosError = function (e) {
  return ee.isObject(e) && !0 === e.isAxiosError;
};
var Ve = Ue,
    De = Ue;
Ve.default = De;
var Qe = Ve,
    We = "object" == (typeof global === "undefined" ? "undefined" : _typeof(global)) && global && global.Object === Object && global,
    Je = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
    He = We || Je || Function("return this")(),
    Fe = He.Symbol,
    Ge = Object.prototype,
    Ke = Ge.hasOwnProperty,
    ze = Ge.toString,
    $e = Fe ? Fe.toStringTag : void 0;
var Xe = Object.prototype.toString;
var Ye = Fe ? Fe.toStringTag : void 0;

function Ze(e) {
  return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Ye && Ye in Object(e) ? function (e) {
    var t = Ke.call(e, $e),
        n = e[$e];

    try {
      e[$e] = void 0;
      var o = !0;
    } catch (e) {}

    var r = ze.call(e);
    return o && (t ? e[$e] = n : delete e[$e]), r;
  }(e) : function (e) {
    return Xe.call(e);
  }(e);
}

function et(e) {
  var t = _typeof(e);

  return null != e && ("object" == t || "function" == t);
}

function tt(e) {
  if (!et(e)) return !1;
  var t = Ze(e);
  return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
}

var nt,
    ot = He["__core-js_shared__"],
    rt = (nt = /[^.]+$/.exec(ot && ot.keys && ot.keys.IE_PROTO || "")) ? "Symbol(src)_1." + nt : "";
var it = Function.prototype.toString;
var at = /^\[object .+?Constructor\]$/,
    st = Function.prototype,
    ct = Object.prototype,
    ut = st.toString,
    lt = ct.hasOwnProperty,
    pt = RegExp("^" + ut.call(lt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

function ft(e) {
  return !(!et(e) || (t = e, rt && rt in t)) && (tt(e) ? pt : at).test(function (e) {
    if (null != e) {
      try {
        return it.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  }(e));
  var t;
}

var dt = function () {
  try {
    var e = ft(t = function (e, t) {
      return null == e ? void 0 : e[t];
    }(Object, "defineProperty")) ? t : void 0;
    return e({}, "", {}), e;
  } catch (e) {}

  var t;
}();

function ht(e, t, n) {
  "__proto__" == t && dt ? dt(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}

function vt(e, t) {
  return e === t || e != e && t != t;
}

var gt = Object.prototype.hasOwnProperty;

function mt(e, t, n) {
  var o = e[t];
  gt.call(e, t) && vt(o, n) && (void 0 !== n || t in e) || ht(e, t, n);
}

function yt(e) {
  return e;
}

function wt(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);

    case 1:
      return e.call(t, n[0]);

    case 2:
      return e.call(t, n[0], n[1]);

    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }

  return e.apply(t, n);
}

var bt = Math.max;

var _t = dt ? function (e, t) {
  return dt(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: (n = t, function () {
      return n;
    }),
    writable: !0
  });
  var n;
} : yt,
    Ot = Date.now;

var xt,
    Et,
    St,
    kt = (xt = _t, Et = 0, St = 0, function () {
  var e = Ot(),
      t = 16 - (e - St);

  if (St = e, t > 0) {
    if (++Et >= 800) return arguments[0];
  } else Et = 0;

  return xt.apply(void 0, arguments);
});

function At(e, t) {
  return kt(function (e, t, n) {
    return t = bt(void 0 === t ? e.length - 1 : t, 0), function () {
      for (var o = arguments, r = -1, i = bt(o.length - t, 0), a = Array(i); ++r < i;) {
        a[r] = o[t + r];
      }

      r = -1;

      for (var s = Array(t + 1); ++r < t;) {
        s[r] = o[r];
      }

      return s[t] = n(a), wt(e, this, s);
    };
  }(e, t, yt), e + "");
}

function Tt(e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}

function It(e) {
  return null != e && Tt(e.length) && !tt(e);
}

var Lt = /^(?:0|[1-9]\d*)$/;

function jt(e, t) {
  var n = _typeof(e);

  return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && Lt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}

function Ct(e) {
  return null != e && "object" == _typeof(e);
}

function Pt(e) {
  return Ct(e) && "[object Arguments]" == Ze(e);
}

var qt = Object.prototype,
    Rt = qt.hasOwnProperty,
    Mt = qt.propertyIsEnumerable,
    Nt = Pt(function () {
  return arguments;
}()) ? Pt : function (e) {
  return Ct(e) && Rt.call(e, "callee") && !Mt.call(e, "callee");
},
    Bt = Array.isArray;

var Ut = "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && exports && !exports.nodeType && exports,
    Vt = Ut && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module && !module.nodeType && module,
    Dt = Vt && Vt.exports === Ut ? He.Buffer : void 0,
    Qt = (Dt ? Dt.isBuffer : void 0) || function () {
  return !1;
},
    Wt = {};

Wt["[object Float32Array]"] = Wt["[object Float64Array]"] = Wt["[object Int8Array]"] = Wt["[object Int16Array]"] = Wt["[object Int32Array]"] = Wt["[object Uint8Array]"] = Wt["[object Uint8ClampedArray]"] = Wt["[object Uint16Array]"] = Wt["[object Uint32Array]"] = !0, Wt["[object Arguments]"] = Wt["[object Array]"] = Wt["[object ArrayBuffer]"] = Wt["[object Boolean]"] = Wt["[object DataView]"] = Wt["[object Date]"] = Wt["[object Error]"] = Wt["[object Function]"] = Wt["[object Map]"] = Wt["[object Number]"] = Wt["[object Object]"] = Wt["[object RegExp]"] = Wt["[object Set]"] = Wt["[object String]"] = Wt["[object WeakMap]"] = !1;

var Jt = "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && exports && !exports.nodeType && exports,
    Ht = Jt && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module && !module.nodeType && module,
    Ft = Ht && Ht.exports === Jt && We.process,
    Gt = function () {
  try {
    var e = Ht && Ht.require && Ht.require("util").types;

    return e || Ft && Ft.binding && Ft.binding("util");
  } catch (e) {}
}(),
    Kt = Gt && Gt.isTypedArray,
    zt = Kt ? function (e) {
  return function (t) {
    return e(t);
  };
}(Kt) : function (e) {
  return Ct(e) && Tt(e.length) && !!Wt[Ze(e)];
},
    $t = Object.prototype.hasOwnProperty;

function Xt(e, t) {
  var n = Bt(e),
      o = !n && Nt(e),
      r = !n && !o && Qt(e),
      i = !n && !o && !r && zt(e),
      a = n || o || r || i,
      s = a ? function (e, t) {
    for (var n = -1, o = Array(e); ++n < e;) {
      o[n] = t(n);
    }

    return o;
  }(e.length, String) : [],
      c = s.length;

  for (var u in e) {
    !t && !$t.call(e, u) || a && ("length" == u || r && ("offset" == u || "parent" == u) || i && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || jt(u, c)) || s.push(u);
  }

  return s;
}

var Yt = Object.prototype;
var Zt = Object.prototype.hasOwnProperty;

function en(e) {
  if (!et(e)) return function (e) {
    var t = [];
    if (null != e) for (var n in Object(e)) {
      t.push(n);
    }
    return t;
  }(e);
  var t,
      n,
      o = (n = (t = e) && t.constructor, t === ("function" == typeof n && n.prototype || Yt)),
      r = [];

  for (var i in e) {
    ("constructor" != i || !o && Zt.call(e, i)) && r.push(i);
  }

  return r;
}

var tn,
    nn = (tn = function tn(e, t) {
  !function (e, t, n, o) {
    var r = !n;
    n || (n = {});

    for (var i = -1, a = t.length; ++i < a;) {
      var s = t[i],
          c = o ? o(n[s], e[s], s, n, e) : void 0;
      void 0 === c && (c = e[s]), r ? ht(n, s, c) : mt(n, s, c);
    }
  }(t, function (e) {
    return It(e) ? Xt(e, !0) : en(e);
  }(t), e);
}, At(function (e, t) {
  var n = -1,
      o = t.length,
      r = o > 1 ? t[o - 1] : void 0,
      i = o > 2 ? t[2] : void 0;

  for (r = tn.length > 3 && "function" == typeof r ? (o--, r) : void 0, i && function (e, t, n) {
    if (!et(n)) return !1;

    var o = _typeof(t);

    return !!("number" == o ? It(n) && jt(t, n.length) : "string" == o && (t in n)) && vt(n[t], e);
  }(t[0], t[1], i) && (r = o < 3 ? void 0 : r, o = 1), e = Object(e); ++n < o;) {
    var a = t[n];
    a && tn(e, a, n, r);
  }

  return e;
}));

var on = function (e, t) {
  return function (n) {
    return e(t(n));
  };
}(Object.getPrototypeOf, Object),
    rn = Function.prototype,
    an = Object.prototype,
    sn = rn.toString,
    cn = an.hasOwnProperty,
    un = sn.call(Object);

function ln(e) {
  if (!Ct(e) || "[object Object]" != Ze(e)) return !1;
  var t = on(e);
  if (null === t) return !0;
  var n = cn.call(t, "constructor") && t.constructor;
  return "function" == typeof n && n instanceof n && sn.call(n) == un;
}

function pn(e) {
  return Object.prototype.toString.call(e);
}

function fn(t, n, o) {
  var r = "";
  if (!t) throw new Error("[util.url.buildUrl]url is required");
  if (!n || null === n) return t;
  if (!(r = function (e, t, n) {
    var o,
        r,
        i = [];
    return Object.keys(e).forEach(function (a) {
      o = e[a], null !== (r = function e(t, n, o, r) {
        void 0 === r && (r = !0);

        var i,
            a = _typeof(n),
            s = 0,
            c = [];

        if ("" === n && r) return "";
        if ("number" === a || "string" === a || "boolean" === a) return [t, o ? encodeURIComponent(n) : n].join("=");
        if (function (e) {
          return "[object Object]" === pn(e);
        }(n)) Object.keys(n).forEach(function (i) {
          c.push(e([t, "[", i, "]"].join(""), n[i], o, r));
        });else if (Array.isArray(n)) for (i = n.length; s < i; s++) {
          c.push(e([t, "[", s, "]"].join(""), n[s], o, r));
        }
        return (c = c.filter(function (e) {
          return null !== e && "" !== function (e) {
            return "[object String]" !== pn(e) ? e : e.replace(/^\s+|\s+$/g, "");
          }(e);
        })).length ? c.join("&") : "";
      }(a, o, t, n)) && "" !== r && i.push(r);
    }), i.join("&");
  }(n, o)) || !r.length) return t;

  var i = function () {
    var t;
    return (null == (t = e.location) ? void 0 : t.protocol) || "https:";
  }();

  return 0 === t.indexOf("//") && (t = i + t), [t, t.indexOf("?") > -1 ? "&" : "?", r].join("");
}

!!e.location && e.location.search.indexOf("test=1");

function dn() {
  var e = L.get("main_login");
  return !e && function () {
    if ("" === vn()) return 0;
    var e = parseInt(L.get("uin").replace(/^o0*/g, ""), 10);
    if ((!e || e <= 1e4) && (!(e = parseInt(L.get("luin").replace(/^o0*/g, ""), 10)) || e <= 1e4)) return 0;
    return e;
  }() && vn() ? "qq" : e || "";
}

function hn() {
  var e = {},
      t = dn();

  if ("qq" === t) {
    var n = vn();
    n && (e.g_tk = gn(n));
    var o = L.get("vqq_vusession");
    o && (e.g_vstk = gn(o));
    var r = L.get("vqq_access_token");
    r && (e.g_actk = gn(r));
  } else if ("wx" === t) {
    var i = L.get("vusession");
    i && (e.g_vstk = gn(i));
    var a = L.get("access_token");
    a && (e.g_actk = gn(a));
  }

  return e;
}

function vn() {
  var e = L.get("skey") || L.get("lskey");
  return e ? e.trim() : "";
}

function gn(e) {
  for (var t = 5381, n = 0, o = e.length; n < o; ++n) {
    t += (t << 5) + e.charAt(n).charCodeAt();
  }

  return 2147483647 & t;
}

var mn,
    yn,
    wn = ["type", "needCSRF", "strict"],
    bn = {
  NETWORK_ERR: "NETWORK_ERR",
  SYSTEM_ERR: "SYSTEM_ERR",
  LOGIC_ERR: "LOGIC_ERR"
},
    _n = /^(http|https):$/.test(null == (mn = e.location) ? void 0 : mn.protocol),
    On = (yn = o.isCSR ? t.request : Qe, new Map([["get", function () {
  var e = c(f.mark(function e(t, n, o) {
    return f.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, xn(o);

          case 2:
            return e.abrupt("return", yn(nn({
              url: t,
              params: n,
              method: "get"
            }, o)));

          case 3:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n, o) {
    return e.apply(this, arguments);
  };
}()], ["post", function () {
  var e = c(f.mark(function e(t, n, o) {
    return f.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, xn(o);

          case 2:
            return e.abrupt("return", yn(nn({
              url: t,
              data: n,
              method: "post"
            }, o)));

          case 3:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n, o) {
    return e.apply(this, arguments);
  };
}()]]));

function xn(e) {
  return En.apply(this, arguments);
}

function En() {
  return (En = c(f.mark(function e(t) {
    var n;
    return f.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (null != t && t.withCredentials && o.isHoneWeb && "undefined" != typeof HoneJSCoreJSBridge) {
              e.next = 2;
              break;
            }

            return e.abrupt("return", t);

          case 2:
            return e.prev = 2, e.next = 5, E();

          case 5:
            n = e.sent, t.headers = t.headers || {}, t.headers.Cookie = n, e.next = 13;
            break;

          case 10:
            e.prev = 10, e.t0 = e.catch(2), g.error("procHeaders error", e.t0);

          case 13:
            return e.abrupt("return", t);

          case 14:
          case "end":
            return e.stop();
        }
      }
    }, e, null, [[2, 10]]);
  }))).apply(this, arguments);
}

function Sn(e, t, n, o) {
  this.code = e, this.msg = t, this.res = n, this.errorType = o || bn.LOGIC_ERR;
}

function kn(e, t, n) {
  return An.apply(this, arguments);
}

function An() {
  return (An = c(f.mark(function e(t, n, o) {
    var r, i, a, s, c, u, l, p, d;
    return f.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return void 0 === t && (t = ""), void 0 === n && (n = {}), void 0 === o && (o = {}), i = (r = o).type, a = r.needCSRF, s = r.strict, c = q(r, wn), u = (i || "get").trim().toLowerCase(), c.withCredentials = !0, "post" === u ? (c.headers = {
              "Content-Type": "text/plain;charset=utf-8"
            }, ln(n) && (n = JSON.stringify(n))) : "get" === u && ln(n) && !n.rpc_data && (n = {
              rpc_data: JSON.stringify(n)
            }), l = "//vip.video.qq.com/rpc/" + t, t.match(/^(https?:)?\/\//) && (l = t), !_n && /^\/\//.test(l) && (l = "https:" + l), _n && !a || (p = hn(), l = fn(l, p)), e.prev = 11, e.next = 14, On.get(u).call(this, l, n, c);

          case 14:
            if (200 === (d = e.sent).status) {
              e.next = 17;
              break;
            }

            throw new Sn(d.status, "网络请求失败", d, bn.SYSTEM_ERR);

          case 17:
            if ((!s || 0 === Number(d.headers["trpc-func-ret"]) && 0 === Number(d.headers["trpc-ret"])) && (s || d.data)) {
              e.next = 19;
              break;
            }

            throw new Sn(d.headers["trpc-func-ret"] || d.headers["trpc-ret"] || -999, d.headers["trpc-error-msg"] || "请求错误", d, bn.LOGIC_ERR);

          case 19:
            return e.abrupt("return", d.data);

          case 22:
            if (e.prev = 22, e.t0 = e.catch(11), !(e.t0 instanceof Sn)) {
              e.next = 26;
              break;
            }

            throw e.t0;

          case 26:
            throw new Sn(0, "网络开小差了！请重试", e.t0, bn.NETWORK_ERR);

          case 27:
          case "end":
            return e.stop();
        }
      }
    }, e, this, [[11, 22]]);
  }))).apply(this, arguments);
}

Sn.prototype.toString = function () {
  return this.msg + (this.code ? "(" + this.code + ")" : "");
}, Sn.prototype.RequestErrorType = bn, Sn.RequestErrorType = bn;
var Tn = ["viptype"],
    In = {
  iphone: 7,
  aphone: 8,
  ipad: 5,
  apad: 6,
  web: 1e3,
  windows: 2e3,
  mac: 2001,
  h5: 3e3
};

function Ln(e) {
  if (void 0 === e && (e = {}), e || (e = {}), e && "kid" === e.service) return kn("trpc.kidsvip.getvipinfo.KidsVipInfoService/KidsVipGetInfo", {}, {
    type: "post",
    timeout: 5e3
  }).then(function (e) {
    var t;
    if (0 === (null == e || null == (t = e.result) ? void 0 : t.code)) return e;
    throw e.result;
  }).catch(function (e) {
    throw {
      code: e.code || -999,
      msg: e.msg || "[request] payvip error"
    };
  });
  var t = e,
      n = t.viptype,
      r = q(t, Tn),
      i = ["svip"];
  return Array.isArray(n) ? i = n.concat(n) : "string" == typeof n && i.push(n), kn("trpc.query_vipinfo.vipinfo.QueryVipInfo/GetVipUserInfoH5", P({
    geticon: 1,
    viptype: i.join("|"),
    platform: (o.isApp || o.isTenvideoUnion) && In[o.device] ? In[o.device] : o.isWeb ? In.web : In.h5
  }, r), {
    type: "post",
    timeout: 5e3
  }).then(function (e) {
    var t;
    if (0 === (null == e || null == (t = e.result) ? void 0 : t.code)) return e;
    throw e.result;
  }).catch(function (e) {
    throw {
      code: e ? e.code || -999 : 502,
      msg: e.msg || "[request] payvip error"
    };
  });
}

var jn = {},
    Cn = jn.toString,
    Pn = jn.hasOwnProperty,
    qn = Pn.toString;

function Rn(e) {
  if (!e || "[object Object]" !== Cn.call(e)) return !1;
  var t = Object.getPrototypeOf(e);
  if (!t) return !0;
  var n = Pn.call(t, "constructor") && t.constructor;
  return "function" == typeof n && qn.call(n) === qn.call(Object);
}

function Mn(e, t) {
  for (var n = e.split("."), o = t.split("."), r = Math.min(n.length, o.length), i = -1, a = 0; a < r; a++) {
    i = n[a] > o[a] ? 1 : n[a] < o[a] ? -1 : 0;
  }

  return i;
}

var Nn = Array.isArray || function (e) {
  return e instanceof Array;
};

function Bn(e, t, n) {
  return Object.keys(t).forEach(function (o) {
    n && (Rn(t[o]) || Nn(t[o])) ? (Rn(t[o]) && !Rn(e[o]) && (e[o] = {}), Nn(t[o]) && !Nn(e[o]) && (e[o] = []), Bn(e[o], t[o], n)) : void 0 !== t[o] && (e[o] = t[o]);
  }), e;
}

function Un(e) {
  return Object.prototype.toString.call(e);
}

function Vn(e, t, n) {
  var o = "";
  if (!e) throw new Error("[util.url.buildUrl]url is required");
  return t && null !== t && (o = Dn(t, n)) && o.length ? (0 === e.indexOf("//") && (e = window.location.protocol + e), [e, e.indexOf("?") > -1 ? "&" : "?", o].join("")) : e;
}

function Dn(e, t, n) {
  var o,
      r,
      i = [];
  return Object.keys(e).forEach(function (a) {
    o = e[a], null !== (r = function e(t, n, o, r) {
      void 0 === r && (r = !0);

      var i,
          a = _typeof(n),
          s = 0,
          c = [];

      if ("" === n && r) return "";
      if ("number" === a || "string" === a || "boolean" === a) return [t, o ? encodeURIComponent(n) : n].join("=");
      if (function (e) {
        return "[object Object]" === Un(e);
      }(n)) Object.keys(n).forEach(function (i) {
        c.push(e([t, "[", i, "]"].join(""), n[i], o, r));
      });else if (Array.isArray(n)) for (i = n.length; s < i; s++) {
        c.push(e([t, "[", s, "]"].join(""), n[s], o, r));
      }
      return (c = c.filter(function (e) {
        return null !== e && "" !== function (e) {
          return "[object String]" !== Un(e) ? e : e.replace(/^\s+|\s+$/g, "");
        }(e);
      })).length ? c.join("&") : "";
    }(a, o, t, n)) && "" !== r && i.push(r);
  }), i.join("&");
}

function Qn(e) {
  return void 0 === e && (e = 0), new Promise(function (t) {
    setTimeout(t, e);
  });
}

function Wn(e, t) {
  this.errMsg = e, this.errCode = t;
}

Wn.prototype.toString = function () {
  return this.errMsg + (this.errCode ? "(" + this.errCode + ")" : "");
}, Wn.BRIDGE_NOT_ALLOW = 50001, Wn.BRIDGE_INJECT_ERROR = 50002, Wn.BRIDGE_INVOKE_TIMEOUT = 50003, Wn.BRIDGE_INVOKE_FAIL = 50004, Wn.BRIDGE_INVOKE_ERROR = 50005, Wn.BRIDGE_LISTENER_INVALID = 50006, Wn.API_NOT_IMPLEMENTED = 50007, Wn.LOGIC_ERROR = 50008;
var Jn = o.isMac ? "callHandler" : o.isWin ? "CallHandler" : "invoke",
    Hn = o.isMac ? "registerHandler" : "on";

function Fn() {
  try {
    var t;
    return e.TenvideoJSBridge || (null == (t = e.top) ? void 0 : t.TenvideoJSBridge);
  } catch (e) {
    return null;
  }
}

var Gn = [];

function Kn() {
  return new Promise(function (e) {
    Fn() ? e() : Gn.push(e);
  });
}

function zn(e, t, n) {
  var o = arguments;
  void 0 === t && (t = null);
  var r = void 0 === n ? {} : n,
      i = r.timeout,
      a = void 0 === i ? 0 : i;
  return console.log("invokeWin", e, t), new Promise(function (n, r) {
    var i;
    a > 0 && (i = setTimeout(function () {
      r(new Wn('TenvideoJSBridge 找不到方法 "invoke"', Wn.BRIDGE_INVOKE_TIMEOUT));
    }, a)), Kn().then(function () {
      i && clearTimeout(i);
      var r = Array.prototype.slice.call(o);
      if (r.shift(), TenvideoJSBridge[e]) return n(TenvideoJSBridge[e].apply(null, r));
      TenvideoJSBridge.CallHandler(e, JSON.stringify(t));
    });
  });
}

function $n(e, t, n) {
  void 0 === t && (t = null);
  var o = (void 0 === n ? {} : n).timeout,
      r = void 0 === o ? 0 : o;
  return console.log("[atom] invoke api=" + e + " params=", t), new Promise(function (n, o) {
    var i;
    r > 0 && (i = setTimeout(function () {
      o(new Wn("[atom] TenvideoJSBridge inject timeout", Wn.BRIDGE_INVOKE_TIMEOUT));
    }, r)), Kn().then(function () {
      if (!Fn()) return o(new Wn("[atom] TenvideoJSBridge 未注册，无法使用", Wn.BRIDGE_INJECT_ERROR));
      if ("function" != typeof Fn()[Jn]) return o(new Wn('[atom] TenvideoJSBridge 找不到方法 "invoke"', Wn.BRIDGE_INVOKE_FAIL));
      var r = Fn()[Jn](e, t, function (t) {
        if (console.log("[atom] invoke callback api=" + e + " response=", t), i && clearTimeout(i), !Rn(t)) {
          var r = null;

          try {
            r = JSON.parse(t);
          } catch (e) {
            o(new Wn("callback result " + JSON.stringify(t) + ' parse error "' + e.message + '", maybe is not supported!', Wn.BRIDGE_INVOKE_ERROR));
          }

          return r ? isNaN(+r.errCode) || 0 == +r.errCode ? Rn(r.result) ? n(r.result) : n(r) : (a = r.errCode, s = r.errMsg, console && console.warn("[invoke api] ", s, " `errCode: " + a + "`"), o(r)) : n(t);
        }

        var a, s;
        return 0 === Object.keys(t).length ? (console && console.warn && console.warn("[atom] api=" + e + " 在此版本暂未支持，请升级到最新版本！"), o(new Wn('callback return "' + JSON.stringify(t) + '", maybe is not supported!', Wn.BRIDGE_INVOKE_ERROR))) : t.result ? n(t.result) : n(t);
      });

      try {
        r && (n(JSON.parse(r)), i && clearTimeout(i));
      } finally {}
    });
  });
}

e.document && document.addEventListener("onTenvideoJSBridgeReady", function () {
  console && console.log("[atom] TenvideoJSBridge is ready for " + o.device);

  for (var e = 0, t = Gn.length; e < t; e++) {
    Gn[e]();
  }

  Gn.length = 0;
}, !1), setTimeout(function () {
  if (o.isApp && o.isWin && e.external) {
    e.TenvideoJSBridge = e.external, TenvideoJSBridge.AddObserver && TenvideoJSBridge.AddObserver("*");
    var t = e.QQLive_OnObserve;
    e.QQLive_OnObserve = function () {
      for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
        n[o] = arguments[o];
      }

      "function" == typeof t && t.apply(this, n), eo.apply(void 0, n);
    }, function () {
      if (e.document) try {
        document.dispatchEvent(new Event("onTenvideoJSBridgeReady"));
      } catch (e) {
        if ("function" == typeof CustomEvent) document.dispatchEvent(new CustomEvent("onTenvideoJSBridgeReady"));else {
          if (!$) throw e;
          $(document).trigger("onTenvideoJSBridgeReady");
        }
      }
    }();
  }
}, 10);
var Xn = {};

function Yn(e, t, n) {
  if (void 0 === t && (t = null), void 0 === n && (n = !1), console.log("[atom] listen event=" + e), "function" != typeof t) throw new Wn("[atom] listener is not a function!", Wn.BRIDGE_LISTENER_INVALID);
  o.isWin || Xn[e] || Kn().then(function () {
    Fn() && Fn()[Hn](e, eo.bind(null, e));
  }), Xn[e] || (Xn[e] = []);
  var r = Xn[e];
  -1 === to(r, t) && r.push({
    listener: t,
    once: n
  });
}

function Zn(e, t) {
  void 0 === t && (t = null);
  var n = Xn[e];

  if (n && n.length) {
    var o = to(n, t);
    -1 !== o && n.splice(o, 1);
  }
}

function eo(e, t) {
  var n = {};
  if (Rn(t)) n = t;else try {
    n = JSON.parse(t);
  } catch (e) {
    o.isApp || o.isWin || console.log(e);
  }
  var r = Xn[e];

  if (r && r.length > 0) {
    for (var i = r.length, a = 0; a < i; a++) {
      r[a] && "function" == typeof r[a].listener && (r[a].listener(n), r[a].once && r.splice(a, 1, null));
    }

    for (var s = [], c = 0; c < i; c++) {
      r[c] && s.push(r[c]);
    }

    Xn[e] = s, console && console.log("[atom] listen callback event=" + e, t);
  }
}

function to(e, t) {
  for (var n = -1, o = 0, r = e.length; o < r; o++) {
    if (e[o].listener === t) {
      n = o;
      break;
    }
  }

  return n;
}

o.isApp && o.isMac && Yn("onMessage", function (e) {
  if (e && e.event) {
    var t = e.data;

    try {
      t = JSON.parse(t);
    } catch (e) {}

    eo(e.event, t);
  }
});

function no(e, t) {
  void 0 === e && (e = ""), void 0 === t && (t = 3e3);

  var n = function (e) {
    var t = document.createElement("div");
    return t.id = Math.random().toString(36).substr(2), t.innerText = e, t.setAttribute("style", "\n    background-color:rgba(0,0,0,0.9);\n    border-radius:5px;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.52);\n    color:#fff;\n    font-size: 14px;\n    opacity:0;\n    padding:16px 20px;\n    position:fixed;\n    left:0;\n    top:0;\n    max-width:80%;\n    -webkit-transition:opacity 0.1s linear;\n    -moz-transition:opacity 0.1s linear;\n    -ms-transition:opacity 0.1s linear;\n    transition:opacity 0.1s linear;\n    word-wrap:break-word;\n    z-index: 9999;\n"), document.body.appendChild(t), setTimeout(function () {
      t.style.marginLeft = -t.offsetWidth / 2 + "px", t.style.marginTop = -t.offsetHeight / 2 + "px", t.style.left = "50%", t.style.top = "44%", t.style.opacity = 1;
    }, 10), t;
  }(e);

  setTimeout(function () {
    n.style.opacity = 0, setTimeout(function () {
      document.body.removeChild(n), n = null;
    }, 100);
  }, t);
}

var oo = /(\d+)(?:\.(\d+))?(?:\.(\d+))?(?:\.([\w-]+))?/,
    ro = n().match(/QQLive(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/),
    io = (null == ro ? void 0 : ro[3]) || "";

function ao() {
  try {
    return new so(io);
  } catch (e) {
    return new so("0.0.0");
  }
}

var so = function () {
  function e(t) {
    var n = e.parse(t),
        o = n[0],
        r = n[1],
        i = n[2],
        a = n[3];
    this.major = o, this.minor = r, this.patch = i, this.build = a;
  }

  var t = e.prototype;
  return t.toString = function () {
    var e = this.toArray(),
        t = e.indexOf(void 0);
    return e.slice(0, t > -1 ? t : e.length).join(".");
  }, t.toArray = function () {
    return [this.major, this.minor, this.patch, this.build];
  }, t.compare = function (t, n) {
    void 0 === n && (n = !0);

    for (var o = t instanceof e ? t.toArray() : e.parse(t), r = this.toArray(), i = 0; i < o.length; i++) {
      var a = r[i] || 0,
          s = o[i] || 0;
      if (a !== s) return a > s;
    }

    return n;
  }, t.equal = function (t) {
    var n = t instanceof e ? t.toArray() : e.parse(t),
        o = n[0],
        r = n[1],
        i = n[2],
        a = n[3];
    return this.major === o && this.minor === r && this.patch === i && this.build === a;
  }, e.parse = function (e) {
    var t = e.match(oo);
    if (!t) throw new Error("[Version.parse]invalid version format(" + e + ")");
    return t.slice(1).map(function (e) {
      var t = parseInt(e, 10);
      return isNaN(t) ? e : t;
    });
  }, e.compare = function (t, n, o) {
    return void 0 === o && (o = !0), new e(t).compare(n, o);
  }, e;
}(),
    co = function () {
  function e() {
    this.name = "Protocol", this.EVENTS = {
      login: "onActionLoginFinish",
      logout: "onActionLogoutFinish"
    };
  }

  var t = e.prototype;
  return t.on = function (e, t) {
    void 0 === e && (e = ""), this.EVENTS[e] && (e = this.EVENTS[e]), Yn(e, t);
  }, t.once = function (e, t) {
    void 0 === e && (e = ""), Yn(e, t, !0);
  }, t.off = function (e, t) {
    void 0 === e && (e = ""), Zn(e, t);
  }, t.invoke = function () {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
      t[n] = arguments[n];
    }

    return $n.apply(this, t);
  }, t.checkApi = function (e) {
    if (void 0 === e && (e = []), !o.isApp) {
      for (var t = {}, n = 0; n < e.length; n++) {
        t[e[n]] = !1;
      }

      return Promise.resolve(t);
    }

    return $n("checkApi", {
      apiList: e
    });
  }, t.close = function () {
    return o.isApp ? $n("close") : window.close();
  }, t.closeH5 = function () {
    if (o.isApp) return $n("closeH5");
  }, t.openLogin = function (e) {
    return void 0 === e && (e = {
      type: "tv"
    }), "string" == typeof e && (e = {
      type: e
    }), $n("actionLogin", e);
  }, t.openUrl = function (e, t) {
    void 0 === e && (e = ""), void 0 === t && (t = {});
    var n = location.protocol.match(/^https?:/) ? location.protocol : "https:";
    return e.match(/^\/\//) && (e = n + e), o.isApp ? e.match(/^(txvideo|tenvideo2|qqlivekid)/) ? this.openView(e) : (t || (t = {}), t.url = e, $n("openUrl", t)) : (location.href = e, Promise.resolve(null));
  }, t.openView = function (e) {
    return void 0 === e && (e = ""), $n("openView", {
      url: e
    });
  }, t.getMainUserInfo = function (e) {
    return void 0 === e && (e = !1), e ? function () {
      var e = L.get("main_login");
      if (!e) return Promise.resolve(null);
      var t = {
        type: e,
        nick: L.get(e + "_nick"),
        headurl: L.get(e + "_head")
      };

      try {
        t.nick = decodeURIComponent(t.nick), t.headurl = decodeURIComponent(t.headurl);
      } catch (e) {}

      return Promise.resolve(t);
    }() : new Promise(function (e) {
      $n("getMainUserInfo").then(function (t) {
        t && t.userInfo ? e({
          headurl: t.userInfo.headImgUrl,
          nick: t.userInfo.nickname,
          type: t.type,
          id: "wx" === t.type ? t.userInfo.openId : t.userInfo.uin
        }) : e(null);
      }).catch(function () {
        e(null);
      });
    });
  }, t.getAppInfo = function () {
    return o.isApp ? $n("getAppInfo") : Promise.resolve({
      isJBOS: 0,
      buildVersion: "",
      supportiap: !1,
      isinreview: !1,
      deviceType: o.device,
      version: "",
      pkgName: "h5",
      systemVersion: "",
      installTime: "0",
      screenResolution: window.screen.availWidth + "*" + window.screen.availHeight
    });
  }, t.getDeviceInfo = function () {
    return !o.isApp || o.isWin ? Promise.resolve({
      guid: L.get("video_guid") || L.get("guid"),
      isJBOS: 0,
      deviceId: ""
    }) : $n("getDeviceInfo");
  }, t.getMainCookie = function (e) {
    return void 0 === e && (e = !1), !o.isApp || o.isWin || e ? Promise.resolve(x(document.cookie)) : new Promise(function (e) {
      $n(o.isLiteApp ? "getCookie" : "getMainCookie").then(function (t) {
        t || e(null);
        var n = x(t.cookie);
        n.main_login = t.type, e(n);
      }).catch(function () {
        e(null);
      });
    });
  }, t.getCookie = function (e) {
    return void 0 === e && (e = "qq"), o.isApp ? $n("getCookie", {
      type: [e]
    }).then(function (t) {
      if (!t || !t[e]) return null;
      var n = x(t[e]);
      return n.main_login = e, n;
    }) : Promise.resolve(x(document.cookie));
  }, t.getPayVip = function (e, t) {
    return void 0 === e && (e = !1), void 0 === t && (t = {}), "[object Object]" === Object.prototype.toString.call(e) && (t = e, e = !0), e || !o.isApp || o.isMac ? Ln(t).catch(function (e) {
      return console.error(e), null;
    }) : $n("getPayVip").then(function (e) {
      return 0 === Object.keys(e).length ? null : e;
    });
  }, t.refreshVipInfo = function () {
    return $n("refreshVipInfo");
  }, t.play = function (e, t, n) {
    void 0 === e && (e = ""), void 0 === t && (t = ""), void 0 === n && (n = {});
    var r = {
      cid: e,
      vid: t
    };
    "[object Object]" === Object.prototype.toString.call(t) && (n = t, r.vid = ""), "[object Object]" === Object.prototype.toString.call(e) && (e.cid || e.vid) && (r = e), Bn(r, n);
    var i = Vn("https://m.v.qq.com/x/play.html", r, !0);
    if (o.isApp) switch (o.device) {
      case "ipad":
      case "iphone":
      case "aphone":
        return this.openView(Vn("tenvideo2://?action=1", {
          cover_id: r.cid,
          video_id: r.vid
        }));

      case "windows":
        return Tenvideoatom.OpenQQLive("qqlive://sso/cid=" + r.cid + "&vid=" + r.vid);

      default:
        location.href = i;
    } else location.href = i;
    return Promise.resolve(null);
  }, t.toast = function (e, t) {
    return void 0 === e && (e = ""), void 0 === t && (t = {
      duration: 3e3,
      native: !0
    }), !o.isApp || o.isMac || o.isWin || !t.native ? (no(e, t.duration), Promise.resolve(null)) : this.checkApi(["toast"]).then(function () {
      return $n("toast", {
        content: e
      });
    }).catch(function () {
      no(e, t.duration);
    });
  }, t.log = function (e) {
    if (void 0 === e && (e = ""), o.isApp) return $n("writeLog", {
      content: e
    });
    console && console.log(e);
  }, t.showLoading = function (e, t) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), new C(e, t);
  }, t.hideLoading = function () {
    !function () {
      var e = document.querySelectorAll(".__atom_toast__");
      if (e && e.length) for (var t = 0, n = e.length; t < n; t++) {
        e[t] && e[t].parentElement && e[t].parentElement.removeChild(e[t]);
      }
    }();
  }, t.getVersion = function () {
    return ao();
  }, t.getDiscountInfo = function (e, t, n) {
    void 0 === n && (n = {});
    var o = n.fromApple,
        r = void 0 === o || o;
    return new Promise(function (n, o) {
      var i = !1;
      $n("getProductIDSDiscountInfo", {
        productids: e,
        offerid: t,
        fromapple: r
      }).then(function (e) {
        i = !0, n(e);
      }).catch(function (e) {
        i = !0, o(e);
      });
      var a = setTimeout(function () {
        i ? clearTimeout(a) : o({
          msg: "jsapi 超时无返回"
        });
      }, 1e4);
    });
  }, t.checkDiscount = function (e, t, n) {
    void 0 === n && (n = {});
    var o = n,
        r = o.limitTimes,
        i = void 0 === r ? 1 : r,
        a = o.fromApple,
        s = void 0 === a || a,
        c = o.onlyApple,
        u = void 0 === c || c;
    return this.getDiscountInfo(Array.isArray(e) ? e : [e], t, s).then(function (e) {
      var t = void 0 === e ? {} : e,
          n = t.ret,
          o = t.only_local,
          r = t.eligibility_info;
      return 0 !== n || !Array.isArray(r) || !r.length || -1 === r.map(function (e) {
        var t = e.num,
            n = e.apple_num;
        return 1 === Number(o) && t < i || 0 === Number(o) && n < i && (!!u || t < i);
      }).indexOf(!1);
    }).catch(function () {
      return !0;
    });
  }, e;
}(),
    uo = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "H5JSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.openLogin = function (e) {
    void 0 === e && (e = {
      type: ""
    }), "string" == typeof e ? e = {
      type: e
    } : "[object Object]" !== Object.prototype.toString.call(e) && (e = {}), e.url || (e.ru = location.href), e.ru = e.url || location.href, top.location.href = "//film.qq.com/weixin/login.html?type=" + e.type + "&ru=" + encodeURIComponent(e.ru);
  }, n.switchLogin = function (e) {
    return void 0 === e && (e = ""), this.openLogin({
      type: e
    });
  }, n.getMainUserInfo = function () {
    return e.prototype.getMainUserInfo.call(this, !0);
  }, n.getUserInfo = function (e) {
    return void 0 === e && (e = []), e.indexOf("qq") < 0 && e.indexOf("wx") < 0 ? Promise.reject(null) : this.getMainUserInfo().then(function (t) {
      if (!t) return null;

      for (var n = {}, o = 0; o < e.length; o++) {
        t.type === e[o] ? n[e[o]] = t : n[e[o]] = null;
      }

      return n;
    });
  }, n.getCookie = function (e) {
    if (void 0 === e && (e = []), e.indexOf("qq") < 0 && e.indexOf("wx") < 0) return Promise.reject(null);

    for (var t = x(document.cookie), n = {}, o = 0; o < e.length; o++) {
      "wx" === e[o] && t.appid && t.openid ? n.wx = {
        appid: t.appid,
        openid: t.openid,
        access_token: t.access_token,
        main_login: "wx"
      } : "qq" === e[o] && (n.qq = {
        uin: t.uin || t.luin,
        skey: t.skey,
        lskey: t.lskey || "",
        main_login: "qq"
      });
    }

    return n;
  }, n.getNetworkState = function () {
    return new Promise(function (e) {
      var t = navigator.userAgent.match(/NetType\/(.*?)\s/i);
      t && t[1] ? e(t[1].toLowerCase()) : e("other");
    });
  }, n.openUrl = function (e) {
    return void 0 === e && (e = ""), location.href = e, Promise.resolve();
  }, n.openView = function (e) {
    return void 0 === e && (e = ""), this.openUrl(e);
  }, t;
}(co))(),
    lo = ["product_type", "price", "amount", "groupid"],
    po = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "IpadJSBridge", t.EVENTS.pay = "PurchaseStatusCallback", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.switchLogin = function (e) {
    return void 0 === e && (e = ""), this.openLogin({
      type: e
    });
  }, n.logout = function () {
    var e = this;
    return this.checkApi(["openLogoutView"]).then(function (t) {
      return t.openLogoutView ? $n("openLogoutView") : e.openLogin();
    });
  }, n.openPay = function (e) {
    var t,
        n = this,
        o = void 0 === e ? {} : e,
        r = o.product_type,
        i = o.price,
        a = o.amount,
        s = o.groupid,
        c = q(o, lo);
    return Bn(c, {
      price: i,
      product_price: i,
      monthgroup: s ? encodeURIComponent("group_id=" + s) : ""
    }), "day" === r ? (t = "openPayByDay", Bn(c, {
      day: a
    })) : (t = "openPay", Bn(c, {
      month: a
    })), $n("PurchaseStatus"), $n(t, c), new Promise(function (e) {
      n.once(n.EVENTS.pay, function (t) {
        t && t.result && "PurchaseSuccess" === t.result.state ? e(P({}, t, {
          paySucc: 1,
          payStatus: 6
        })) : e(P({}, t, {
          paySucc: 0,
          payStatus: t && t.result && "PurchaseCancel" === t.result.state ? 12 : -1
        }));
      });
    });
  }, n.doAction = function (e) {
    return $n("doAction", {
      url: e
    });
  }, n.loginAlert = function () {
    return $n("loginAlert");
  }, n.copyToClipBoard = function (e) {
    return $n("copyToClipBoard", {
      content: e
    });
  }, n.launch3rdApp = function (e) {
    return void 0 === e && (e = ""), $n("launch3rdApp", {
      pkgName: e
    });
  }, n.isInstalled = function (e) {
    return void 0 === e && (e = ""), $n("isInstalled", {
      pkgName: e
    });
  }, n.setMoreInfo = function (e) {
    return void 0 === e && (e = {}), $n("setMoreInfo", P({
      hasRefresh: !0,
      hasShare: !0,
      hasFollow: !0
    }, e));
  }, n.openToolsDialog = function (e) {
    return void 0 === e && (e = {}), $n("shareTo", e);
  }, n.launch = function (e) {
    return void 0 === e && (e = ""), $n("isInstalled", {
      pkgName: e
    }).then(function (t) {
      var n = t.installed;
      return !(void 0 === n || !n) && ($n("launch3rdApp", {
        pkgName: e
      }), !0);
    });
  }, n.openView = function (e, t) {
    void 0 === e && (e = "");
    var n = (void 0 === t ? {} : t).type;

    if (e.match(/^(https?:)?\/\//)) {
      var o = "Html5Activity";
      "pop" === n ? o = "PopHollywoodH5Activity" : e.match(/\.qq\.com/) && (o = "HollywoodH5Activity"), e = "txvideo://v.qq.com/" + o + "?url=" + encodeURIComponent(e);
    }

    if (!e.match(/^(txvideo|tenvideo2|qqlive)/)) return this.toast("非法 Url 地址！");
    $n("openView", {
      url: e
    });
  }, n.download3rdApp = function (e) {
    return void 0 === e && (e = {}), $n("download3rdApp", e);
  }, t;
}(co))(),
    fo = r(i(function (e) {
  e.exports = function (e, t, n, o, r) {
    var i = {};
    return Object.keys(o).forEach(function (e) {
      i[e] = o[e];
    }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, o) {
      return o(e, t, n) || n;
    }, i), r && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(r) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}));

function ho(e, t) {
  return void 0 === t && (t = !0), function (n, o, r) {
    var i = r.value;
    return r.value = function () {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++) {
        r[a] = arguments[a];
      }

      if (!this.getVersion) return i.apply(this, r);
      var s = this.getVersion();
      if (s.compare(e, t)) return i.apply(this, r);
      throw new xo(o + " is unsupported for " + s + "(supported from: " + e + ")");
    }, r;
  };
}

var vo,
    go,
    mo,
    yo,
    wo,
    bo,
    _o,
    Oo,
    xo = function () {
  function e(e) {
    void 0 === e && (e = "api is unsupported for this version"), this.code = -1e4, this.msg = e;
  }

  return e.prototype.toString = function () {
    return this.msg + "(" + this.code + ")";
  }, e;
}(),
    Eo = ["id", "price", "product_type", "amount"],
    So = new (vo = ho("5.7.0"), fo((go = function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "KidJSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.logout = function () {
    return $n("logout", {
      needBack: !1
    });
  }, n.switchLogin = function (e) {
    return void 0 === e && (e = ""), this.openLogin({
      type: e
    });
  }, n.checkDiscount = function () {
    for (var t, n = arguments.length, o = new Array(n), r = 0; r < n; r++) {
      o[r] = arguments[r];
    }

    return (t = e.prototype.checkDiscount).call.apply(t, [this].concat(o));
  }, n.openPay = function (e) {
    var t = this;
    void 0 === e && (e = {});
    var n = e,
        o = n.id,
        r = n.price,
        i = n.product_type,
        a = n.amount,
        s = q(n, Eo);
    if (!o) throw {
      errCode: -10,
      errMsg: "[atom.openPay]miss required option(options.id)"
    };
    return Bn(s, {
      product_price: r,
      productprice: r,
      id: o,
      productid: o,
      product_type: "month",
      month: a
    }), "serial" === i && (s.serialpay = 1), $n("openPay", s), new Promise(function (e, n) {
      t.once("PurchaseStatusCallback", function (t) {
        var o = t && t.result && t.result.state ? t.result.state : "";

        switch (console.log("kid:openPay:PurchaseStatusCallback", o, t), o) {
          case "PurchaseSuccess":
            e({
              paySucc: 1,
              payStatus: 1
            });
            break;

          case "PurchaseCancel":
            n({
              paySucc: 0,
              payStatus: 12
            });
            break;

          default:
            n({
              paySucc: 0,
              payStatus: -1
            });
        }
      });
    });
  }, n.postMessage = function (e, t) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), this.invoke("publishMsgToAllWebView", {
      messageName: e,
      messageParams: t
    });
  }, t;
}(co)).prototype, "checkDiscount", [vo], Object.getOwnPropertyDescriptor(go.prototype, "checkDiscount"), go.prototype), go)(),
    ko = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "MacJSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.openPay = function (e) {
    return void 0 === e && (e = {}), $n("vipPurchase", e);
  }, n.openLogin = function () {
    return $n("login");
  }, n.switchLogin = function () {
    return $n("switchAccount");
  }, n.logout = function () {
    return $n("logout");
  }, n.getMainCookie = function () {
    return Promise.resolve(x(document.cookie));
  }, n.getMainUserInfo = function () {
    return $n("getUserInfo").then(function (e) {
      return P({
        nick: e.nickname,
        head: e.avatar
      }, e);
    });
  }, n.getDeviceInfo = function () {
    return this.getMainCookie().then(function (e) {
      var t = navigator.userAgent.match(/Mac OS X ([0-9]{1,2}_){2}[0-9]{2}/);
      return {
        guid: e.guid,
        omgid: 0,
        deviceModel: "Mac",
        systemVersion: t ? t[1] : "",
        screenWidth: window.screen.width,
        screenHeight: window.screen.height
      };
    });
  }, n.getAppInfo = function () {
    return $n("getSystemInfo").then(function (e) {
      return {
        isJBOS: 0,
        buildVersion: e.clientBuildVersion,
        supportiap: location.search.indexOf("AppStore=1") > -1,
        isinreview: !1,
        version: e.clientVersion,
        pkgName: "com.tencent.qqlive"
      };
    });
  }, n.getNetworkState = function () {
    return $n("getNetworkInfo");
  }, n.getRemoteConfigs = function () {
    return $n("getRemoteConfigs");
  }, n.getLoginStatus = function () {
    return $n("getLoginStatus");
  }, n.switchAccount = function () {
    return $n("switchAccount");
  }, n.payForFilmSuccess = function () {
    return $n("onPurchaseSuccessed");
  }, n.vipInfoChangeSuccess = function () {
    return $n("onProfileForQQLiveDidUpdated");
  }, n.openSheetWindow = function (e) {
    return $n("openSheetWindow", {
      url: e
    });
  }, n.closeSheetWindow = function () {
    return $n("closeSheetWindow");
  }, n.openModalWindow = function (e, t) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), $n("openModalWindow", P({
      url: e
    }, t));
  }, n.closeModalWindow = function () {
    return $n("closeModalWindow");
  }, n.setWindowSize = function () {
    return $n("setWindowSize");
  }, n.setViewVisibility = function (e) {
    return void 0 === e && (e = !1), $n("setViewVisibility", {
      visible: e
    });
  }, n.getViewVisibility = function () {
    return $n("getViewVisibility");
  }, n.play = function (e) {
    return void 0 === e && (e = {}), $n("play", e);
  }, n.playLive = function (e) {
    return void 0 === e && (e = {}), $n("play", {
      params: e
    });
  }, n.closeLoading = function () {
    return $n("stopPageLoadingAnimation");
  }, n.openUrl = function (e) {
    return void 0 === e && (e = ""), $n("windowOpen", {
      url: e
    });
  }, n.openView = function (e) {
    return void 0 === e && (e = ""), e.match(/^qqlive:\/\//) ? (location.href = e, Promise.resolve()) : this.openUrl(e);
  }, n.postMessage = function (e, t) {
    return t = "object" == _typeof(t) ? JSON.stringify(t) : "{}", this.invoke("message", {
      event: e,
      data: t
    });
  }, t;
}(co))(),
    Ao = (null == (mo = n().match(/(?:QQLive)\/(\d+)/)) ? void 0 : mo[1]) || "",
    To = (null == (yo = n().match(/(?:QQLive)\/(?:\d+)\/(\d+)/)) ? void 0 : yo[1]) || "",
    Io = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "PCJSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.invoke = function () {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
      t[n] = arguments[n];
    }

    return zn.apply(this, t);
  }, n.openLogin = function (e) {
    return void 0 === e && (e = {}), location.search.match(/(cid|vid|pid)=[a-z0-9]+/) && (e.parent = "player"), this.invoke("login", e);
  }, n.switchLogin = function (e, t) {
    return void 0 === t && (t = {}), Rn(e) ? t = e : "string" == typeof e && (t = P({
      type: e
    }, t)), /(cid|vid|pid)=[a-z0-9]+/.test(location.search) && (t = P({}, t, {
      parent: "player"
    })), this.invoke("switchAccount", t);
  }, n.logout = function () {
    return this.invoke("logout");
  }, n.getAppInfo = function () {
    var e = this;
    return new Promise(function (t) {
      t(e.invoke("GetProtocalVersion").then(function (e) {
        return {
          deviceType: "windows",
          version: e,
          screenResolution: window.screen.availWidth + "*" + window.screen.availHeight
        };
      }));
    });
  }, n.getMainUserInfo = function () {
    var e = this;
    return new Promise(function (t) {
      e.invoke("GetMyData").then(function (e) {
        try {
          e && ("wx" === (e = JSON.parse(e)).main_login ? t({
            headurl: e.wx_head,
            nick: e.wx_nick,
            appid: e.appid,
            openid: e.openid,
            VipLevel: e.VipLevel,
            HollywoodType: e.HollywoodType,
            main_login: e.main_login,
            type: e.main_login,
            access_token: e.access_token
          }) : "qq" === e.main_login && t({
            headurl: e.QQPortraitUrl40,
            id: e.Uin,
            nick: e.Name,
            sex: e.Gender,
            main_login: e.main_login,
            VipLevel: e.VipLevel,
            HollywoodType: e.HollywoodType,
            type: e.main_login,
            appid: e.vqq_appid,
            openid: e.vqq_openid,
            access_token: e.vqq_access_token
          })), t(null);
        } finally {
          t(null);
        }
      });
    });
  }, n.play = function (e, t) {
    var n = {
      cid: e,
      vid: t
    };
    return "[object Object]" === Object.prototype.toString.call(e) && (e.cid || e.vid) && (n = e), this.invoke("OpenQQLive", "qqlive://sso/cid=" + n.cid + "&vid=" + n.vid);
  }, n.postMessage = function (e, t, n) {
    t = "object" == _typeof(t) ? JSON.stringify(t) : "{}", this.invoke("NotifyObservers", e, t, !!n);
  }, n.getVersion = function () {
    return Ao;
  }, n.getProtocalVersion = function () {
    return To;
  }, n.loginQQLiveWithPay = function (e, t) {
    var n = t || "player",
        o = "";
    return o = Vn(o = To >= 50150915 ? "https://film.qq.com/wx/wx_login_cli_v2.html" : "https://film.qq.com/wx/wx_login_cli.html", e), this.invoke("OpenQQLive", "qqlive://sso/login=1&withpay=1&parent=" + n + "&withpayurl=" + encodeURIComponent(o));
  }, n.openMinipay = function (e, t) {
    var n = Vn("https://cache.tv.qq.com/bigportal/film/pay/bp_minipay.html", e),
        o = t || "main";
    return this.invoke("OpenQQLive", "qqlive://sso/parent=" + o + "&minipayurl=" + encodeURIComponent(n));
  }, n.openSinglePay = function (e, t) {
    var n = Vn("https://cache.tv.qq.com/bigportal/film/pay/bp_paycenter.html", e),
        o = t || "main";
    return this.invoke("OpenQQLive", "qqlive://sso/parent=" + o + "&minipayurl=" + encodeURIComponent(n));
  }, n.openVipPaymask = function (e, t, n) {
    var o = n || "player",
        r = Vn(e, t);
    return this.invoke("OpenQQLive", "qqliveex://openVipPaymask/parent=" + o + "&vippaymaskurl=" + encodeURIComponent(r));
  }, n.openMask = function (e, t, n, o, r, i) {
    var a = r || "腾讯视频",
        s = i ? 1 : 0,
        c = Vn(e, t),
        u = n || 500,
        l = o || 500;
    return this.invoke("HintBrowseDlg", encodeURIComponent(c), u, l, encodeURIComponent(a), s);
  }, n.loginWithWeChatPay = function (e, t) {
    var n = t || "main";
    e.sourceType || (e.sourceType = "openvip");
    var o = Vn("//cache.tv.qq.com/win/vip/paymask.html", e);
    return this.invoke("OpenQQLive", "qqlive://sso/login=1&withwechatpay=1&parent=" + n + "&withwechatpayurl=" + encodeURIComponent(o));
  }, n.removeCallback = function (e, t) {
    void 0 === t && (t = null), Zn(e, t);
  }, n.openVip = function (e, t) {
    try {
      var n = this,
          o = t || "main",
          r = e.wxConfig || e.qqConfig || e;
      (e.wxConfig || e.qqConfig) && console.warn("新版本不需要区分微信和QQ的传参 统一拉起minipay"), r || console.error("不传开通浮层参数会导致aid流水错误"), (r = r || {})._version = Ao, r.aid_version = "V0", this.getMainUserInfo().then(function (e) {
        e && e.main_login ? To > 50190815 || "qq" === e.main_login ? n.openMinipay(r, o) : (r.source = r.source || r._source, r.sourceType = r.sourceType || ("open" + r.tab).toLowerCase(), n.loginWithWeChatPay(r, o)) : n.loginQQLiveWithPay({
          aid: "V0$$2:2000$4:" + (r.source || r._source) + "$11:2$3:" + Ao
        }, o);
      });
    } catch (e) {
      console.error(e);
    }
  }, n.openModalWindow = function (e, t) {
    return void 0 === t && (t = {}), t.browser ? this.invoke("OpenQQLive", e) : (t.width || (t.width = 760), t.height || (t.height = 500), t.title || (t.title = " "), this.openView("qqlive://openhintbrowsedlg/" + Dn(P({
      hintbrowseurl: e
    }, t), !0)));
  }, n.openUrl = function (e) {
    var t = location.protocol.match(/^https?:/) ? location.protocol : "https:";
    e.match(/^\/\//) && (e = t + e), window.open(e);
  }, n.openView = function (e) {
    return void 0 === e && (e = ""), e.match(/^qqlive:\/\//) ? this.invoke("OpenQQLive", e) : this.openUrl(e);
  }, n.close = function () {
    window.external.Close();
  }, t;
}(co))(),
    Lo = ["vipType", "id", "price", "groupid"],
    jo = ["product_type", "amount"],
    Co = ["amount", "product_type"],
    Po = ["amount", "product_type"],
    qo = ["offline", "wifi", "2g", "3g", "4g", "other"],
    Ro = /^https?:/.test(null == (wo = e.location) ? void 0 : wo.protocol) ? location.protocol : "https:",
    Mo = n().match(/QQLive(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/),
    No = (null == Mo || null == (bo = Mo[3]) ? void 0 : bo.slice(0, 5)) || "";

var Bo = new (_o = ho("6.1.9"), fo((Oo = function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "PhoneJSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.logout = function () {
    var e = this;
    return this.checkApi(["logout"]).then(function (t) {
      return t.logout ? $n("logout", {
        needBack: !1
      }) : e.openLogin();
    });
  }, n.getUserInfo = function (e) {
    return void 0 === e && (e = []), e.indexOf("qq") < 0 && e.indexOf("wx") < 0 ? Promise.reject(null) : $n("getUserInfo", {
      type: e
    }).then(function (e) {
      if (e) {
        var t = {};
        return Object.keys(e).forEach(function (n) {
          var o = e[n].headImgUrl ? e[n].headImgUrl.replace(/^https:?/, "") : "";
          t[n] = {
            headurl: o,
            nick: e[n].nickname,
            type: n,
            id: "wx" === n ? e[n].openId : e[n].uin
          };
        }), t;
      }

      return null;
    });
  }, n.getCookie = function (e) {
    return void 0 === e && (e = []), e.indexOf("qq") < 0 && e.indexOf("wx") < 0 ? Promise.reject(null) : $n("getCookie", {
      type: e
    }).then(function (e) {
      if (!e) return null;
      var t = {};
      return Object.keys(e).forEach(function (n) {
        t[n] = x(e[n]), t[n].main_login = n;
      }), t;
    });
  }, n.getMainLoginType = function () {
    return $n("getMainLoginType");
  }, n.goBack = function () {
    return $n("goBack");
  }, n.openPaySingle = function () {
    return $n("openPaySingle");
  }, n.switchLogin = function (e) {
    var t = this;
    return new Promise(function (n, r) {
      $n("switchLoginState", {
        userType: e
      }).then(function (e) {
        o.isAndroid || n(e);
      }).catch(r), t.once("onSwitchLoginStateResponse", function (e) {
        e && e.result && e.result.switchResult ? n(e) : r(new Wn("login fail", e.code || -1));
      });
    });
  }, n.showMessageButton = function (e) {
    return void 0 === e && (e = {
      unreadNum: 0,
      url: "",
      show: !1
    }), $n("showMessageButton", e);
  }, n.openToolsDialog = function () {
    return $n("openToolsDialog");
  }, n.setMoreInfo = function (e) {
    return void 0 === e && (e = {}), $n("setMoreInfo", P({
      hasRefresh: !0,
      hasShare: !0,
      hasFollow: !0
    }, e));
  }, n.getLocation = function () {
    return $n("getLocation");
  }, n.getNetworkState = function () {
    return $n("getNetworkState").then(function (e) {
      var t = e.state;
      return qo[void 0 === t ? 0 : t] || "offline";
    });
  }, n.disablePageBounces = function (e) {
    return void 0 === e && (e = !0), $n("disablePageBounces", {
      disable: e
    });
  }, n.shareImageByUrl = function (e) {
    return void 0 === e && (e = ""), $n("shareLocalImage", {
      imageUrl: e
    });
  }, n._checkShareLocalImageAPI = function () {
    return !(Mn(No, "6.0.0") < 0) && (!!o.isIos || !(Mn(No, "6.2.1") > 0 && Mn(No, "6.2.5") < 0));
  }, n.shareLocalImage = function (e) {
    var t = this;
    return void 0 === e && (e = ""), this.checkApi(["shareLocalImage"]).then(function (n) {
      return n.shareLocalImage && t._checkShareLocalImageAPI() ? $n("shareLocalImage", {
        imgbase64String: e.replace(/^data:image\/(png|jpeg|webp);base64,/, "")
      }) : (t.showLoading(), (r = e, new Promise(function (e, t) {
        $.ajax({
          url: "https://node.video.qq.com/x/services/imageupload",
          type: "POST",
          data: {
            base64: r
          },
          xhrFields: {
            withCredentials: !0
          },
          success: function success(n) {
            n && 0 === n.ret && n.result && n.result.access && n.result.access.length > 0 ? e(n.result.access[0]) : t();
          },
          error: function error(e) {
            t(e);
          }
        });
      })).then(function (e) {
        var n = Ro + "//" + e;
        return o.isIos ? t.saveImage(n).then(function () {
          return t.hideLoading(), t.shareImageByUrl(n);
        }) : (t.hideLoading(), t.shareImageByUrl(n));
      }));
      var r;
    }).catch(function (e) {
      t.hideLoading(), t.toast("分享失败！"), console.error(e);
    });
  }, n.saveImage = function (e) {
    return $n("saveImage", {
      url: e
    });
  }, n.download3rdApp = function (e) {
    var t = this;
    return void 0 === e && (e = {}), new Promise(function (n, r) {
      $n("download3rdApp", e).then(function () {
        if (o.isIos) setTimeout(function () {
          n();
        }, 2e3);else var i = 0,
            a = new Date().getTime(),
            s = setInterval(function () {
          $n("checkDowload3rdAppState", {
            downloadUrl: e.downloadUrl,
            packageName: e.packageName
          }).then(function (e) {
            if (e.progress >= 100) t.hideLoading(), n(), clearInterval(s);else if (i > e.progress) {
              clearInterval(s), new Date().getTime() - a > 3e3 && (t.hideLoading(), t.toast("可能网络异常或者中断下载，请稍后重试！"), r({
                msg: "可能网络异常或者中断下载，请稍后重试！",
                code: 504
              }));
            } else i = e.progress, t.showLoading("下载中" + (e.progress > 0 ? "(" + Math.floor(e.progress) + "%)" : ""));
          }).catch(function (e) {
            t.hideLoading(), t.toast(e.msg || "网络异常，请稍后重试！"), r({
              msg: e.msg || "网络异常，请稍后重试！",
              code: e.code || 504
            });
          });
        }, 60);
      });
    });
  }, n.checkDiscount = function () {
    for (var t, n = arguments.length, o = new Array(n), r = 0; r < n; r++) {
      o[r] = arguments[r];
    }

    return (t = e.prototype.checkDiscount).call.apply(t, [this].concat(o));
  }, n.openPay = function (e) {
    void 0 === e && (e = {});
    var t = e,
        n = t.vipType,
        o = void 0 === n ? "vip" : n,
        r = t.id,
        i = t.price,
        a = t.groupid,
        s = q(t, Lo);
    if (!r) throw {
      errCode: -10,
      errMsg: "[atom.openPay]miss required option(options.id)"
    };

    switch (Bn(s, {
      product_price: i,
      productprice: i,
      id: r,
      productid: r,
      monthgroup: a ? encodeURIComponent("group_id=" + a) : ""
    }), o) {
      case "vip":
        return this._openPay(s);

      case "svip":
        return this._openSVIPPay(s);

      default:
        return this._openCommonPay(s);
    }
  }, n._openPay = function (e) {
    var t = this,
        n = e.product_type,
        o = e.amount,
        r = q(e, jo);
    Bn(r, "day" === n ? {
      product_type: n,
      day: o
    } : {
      product_type: "month",
      month: o
    }), "serial" === n && (r.serialpay = 1);
    var i = "day" === n ? "openPayByDay" : "openPay";
    return this.getVersion().compare("6.4.1") ? $n(i, r) : new Promise(function (e, n) {
      t.once("onIAPPaySuccess", function () {
        e({
          paySucc: 1
        });
      }), $n(i, r).then(e).catch(n);
    });
  }, n._openSVIPPay = function (e) {
    if (!e.offerid) throw {
      errCode: -10,
      errMsg: "[atom._openSVIPPay]miss required option(options.offerid)"
    };
    var t = e.amount,
        n = e.product_type,
        o = q(e, Co);
    return Bn(o, {
      month: t,
      payingitem: t,
      ap: 0
    }), "serial" === n && (o.serialpay = 1), $n("purchaseSVIP", o);
  }, n._openCommonPay = function (e) {
    if (!e.offerid) throw {
      errCode: -10,
      errMsg: "[atom._openCommonPay]miss required option(options.offerid)"
    };
    var t = e.amount,
        n = e.product_type,
        o = q(e, Po);
    return Bn(o, {
      month: t,
      payingitem: t,
      ap: 0,
      viptype: 100
    }), "serial" === n && (o.serialpay = 1), this.checkApi(["commonOpenPay"]).then(function (e) {
      if (!e.commonOpenPay) throw new xo("commonOpenPay is unsupported for this version");
      return $n("commonOpenPay", o);
    });
  }, n.closeH5 = function () {
    return this.invoke("closeH5");
  }, n.postMessage = function (e, t) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), this.invoke("publishMsgToAllWebView", {
      messageName: e,
      messageParams: t
    });
  }, t;
}(co)).prototype, "checkDiscount", [_o], Object.getOwnPropertyDescriptor(Oo.prototype, "checkDiscount"), Oo.prototype), Oo)(),
    Uo = r(i(function (e) {
  e.exports = function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
})),
    Vo = {
  1: "wx",
  2: "qq"
},
    Do = 1,
    Qo = [],
    Wo = new (function (t) {
  function n() {
    var n, r;
    return (r = t.call(this) || this).name = "QQMusicBridge", e.document ? (null == (n = document) || n.addEventListener("WebViewJavascriptBridgeReady", function () {
      !e.M && o.isIos && (window.M = {
        client: Uo(r)
      }), Qo.length > 0 && (Qo.forEach(function (e) {
        var t;
        (t = r).callNative.apply(t, e);
      }), Qo.length = 0);
    }), r) : Uo(r);
  }

  s(n, t);
  var r = n.prototype;
  return r.invoke = function (e, t, n) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 5e3
    }), "function" == typeof this[e] ? this[e](t, n) : this.call(e, t, n);
  }, r.call = function (e, t, n) {
    var o = this;
    void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 5e3
    }), console.log("[QQMusicBridge] invoke " + e + " params=", t);
    var r = e.match(/^([a-z]+)\.([a-z]+)?/i) || ["", "core", e],
        i = r[1],
        a = r[2];
    return new Promise(function (e, r) {
      var s;
      window.M || (n.timeout = 0), n.timeout > 0 && (s = setTimeout(function () {
        r(new Wn("[QQMusicBridge] invoke '" + a + "' timeout " + n.timeout + "ms"));
      }, n.timeout)), o.callNative(i, a, t, function (t) {
        void 0 === t && (t = {}), console.log("[QQMusicBridge] invoke " + a + " callback=", t), clearTimeout(s), t && 0 === t.code ? e(t.data) : r(new Wn(t.msg, t.code));
      });
    });
  }, r.callNative = function (e, t, n, o) {
    if (void 0 === t && (t = ""), void 0 === n && (n = {}), window.M) {
      if (window.M) return window.M.client.invoke(e, t, n, o);
      var r = "qqmusic_" + Do + "_" + new Date().getTime();
      Do += 1, "function" == typeof o && (window[r] = o);
      var i = P({}, n),
          a = "qqmusic://qq.com/" + e + "/" + t + "?p=" + encodeURIComponent(JSON.stringify(i)) + "#" + r,
          s = document.createElement("iframe");
      s.style.cssText = "width:0;height:0;border:none;position:fixed;top:0;left:0;", s.setAttribute("data-html2canvas-ignore", "true"), s.src = a, s.onload = function () {
        this.remove();
      }, document.body.appendChild(s);
    } else Qo.push([e, t, n, o]);
  }, r.on = function (e, t) {
    "onActionLoginFinish" === e && (e = "loginState"), this.call("event.on", {
      event: e
    }, t);
  }, r.getDeviceInfo = function () {
    return this.call("device.getDeviceInfo");
  }, r.getMainUserInfo = function () {
    return this.call("data.getUserInfo", {}).then(function (e) {
      var t = Vo[L.get("tmeLoginType")];
      return t ? P({
        headurl: e.face,
        nick: e.nickname,
        type: t
      }, e) : null;
    });
  }, r.openLogin = function (e) {
    void 0 === e && (e = {});
    var t = !!Vo[L.get("tmeLoginType")];
    return t && this.call("ui.logout"), this.call("ui.login", e, {
      timeout: 3e5
    }).then(function () {
      return o.isIos && location.reload(), !0;
    }).catch(function (e) {
      throw t && location.reload(), e;
    });
  }, r.switchLogin = function (e) {
    return this.openLogin({
      type: e
    });
  }, r.switchLoginState = function () {
    return this.switchLogin();
  }, r.close = function () {
    return this.call("ui.closeWebview");
  }, r.closeH5 = function () {
    return this.close();
  }, r.openUrl = function (e) {
    return void 0 === e && (e = ""), e.match(/^https?:\/\//) ? this.call("ui.openUrl", {
      url: e,
      special: "qqmv"
    }).catch(function () {
      location.href = e;
    }) : this.openView(e);
  }, r.openView = function (e) {
    return void 0 === e && (e = ""), location.href = e, Promise.resolve();
  }, r.saveImage = function (e) {
    var t = e.url,
        n = void 0 === t ? "" : t;
    return this.call("media.saveImage", {
      content: n
    });
  }, r.setTitle = function (e) {
    return void 0 === e && (e = ""), this.call("ui.refreshTitle", {
      title: e
    });
  }, n;
}(co))(),
    Jo = 1,
    Ho = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "QQSportsBridge", o.isQQSports && (t.setTitle(document.title), o.isIos && t.invoke("showWebContent").catch(function () {})), t;
  }

  s(t, e);
  var n = t.prototype;
  return n.invoke = function (e, t, n) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 5e3
    }), "function" == typeof this[e] ? this[e](t, n) : this.call(e, t, n);
  }, n.call = function (e, t, n) {
    var o = this;
    return void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 5e3
    }), console.log("[QQSportsBridge] invoke " + e + " params=", t), new Promise(function (r, i) {
      var a;
      n.timeout > 0 && (a = setTimeout(function () {
        i(new Wn("[QQSportsBridge] invoke '" + e + "' timeout " + n.timeout + "ms"));
      }, n.timeout)), o.callNative(e, t, function (t) {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
          o[i - 1] = arguments[i];
        }

        console.log("[QQSportsBridge] invoke " + e + " callback=", t, o), clearTimeout(a), !t && o.length > 0 ? r(o) : r(t);
      });
    });
  }, n.callNative = function (e, t, n) {
    void 0 === e && (e = ""), void 0 === t && (t = {});
    var r = "qqsports_" + Jo + "_" + new Date().getTime();
    Jo += 1, "function" == typeof n && (window[r] = n);
    var i = P({}, t, {
      callbackName: r
    });
    if (o.isAndroid) window.QQSportsBridge && "function" == typeof window.QQSportsBridge.callNativeMethod ? window.QQSportsBridge.callNativeMethod(location.href, "js_" + e + "(" + JSON.stringify(i) + ")") : alert("js_" + e + "(" + JSON.stringify(i) + ")");else {
      var a = Object.entries(i).map(function (e) {
        var t = e[0],
            n = e[1];
        return t + "=" + encodeURIComponent("object" == _typeof(n) ? JSON.stringify(n) : n);
      }),
          s = (o.isIpad ? "http" : "https") + "://sports.qq.com/jsBridge/" + e + "?" + a.join("&"),
          c = document.createElement("iframe");
      c.style.cssText = "width:1;height:1px;border:none;position:fixed;top:0;left:0;", c.setAttribute("data-html2canvas-ignore", "true"), c.onload = function () {
        this.remove();
      }, c.src = s, document.body.appendChild(c);
    }
  }, n.getDeviceInfo = function () {
    return this.call("getDeviceInfo");
  }, n.getMainUserInfo = function () {
    return e.prototype.getMainUserInfo.call(this, !0);
  }, n.openLogin = function (e) {
    var t = (void 0 === e ? {} : e).type,
        n = void 0 === t ? "" : t;
    return L.get("main_login") ? this.switchLogin(n) : this.call("login", {}, {
      timeout: 3e5
    }).then(function (e) {
      if (!e) throw new Wn("登录失败", -1);
      return o.isIos && location.reload(), {
        isLogin: e
      };
    });
  }, n.switchLogin = function (e) {
    return void 0 === e && (e = ""), this.call("switchLogin", {
      type: e
    }, {
      timeout: 3e5
    }).then(function () {
      return o.isIos && location.reload(), !0;
    });
  }, n.switchLoginState = function (e) {
    return void 0 === e && (e = ""), this.switchLogin(e);
  }, n.openUrl = function (e, t) {
    if (void 0 === e && (e = ""), void 0 === t && (t = {
      title: document.title
    }), !e.match(/^https?:\/\//)) return this.openView(e);
    var n = {
      type: 1
    };
    return o.isIos ? (n.url = e, n.title = t.title || "") : n.param = {
      url: e,
      title: t.title || ""
    }, this.call(o.isIos ? "open" : "openNativePage", n);
  }, n.openView = function (e) {
    return void 0 === e && (e = ""), this.call(o.isIos ? "open" : "openNativePage", {
      type: 2,
      url: e
    });
  }, n.saveImage = function (e) {
    var t = e.url,
        n = void 0 === t ? "" : t;
    if (!n || !n.match(/^https?:\/\//)) throw new Wn("当前环境仅支持下载在线图片", -1001);
    return this.call("saveImage", {
      image: n
    });
  }, n.setTitle = function (e) {
    return void 0 === e && (e = ""), this.call("setTitle", {
      title: e
    });
  }, n.shareTo = function (e) {
    var t = e.type,
        n = e.imgbase64,
        o = /^data:image\/\w+;base64,/;
    if (!n || !n.match(o)) throw new Wn("shareTo仅支持分享base64图片", -1001);
    var r = {
      qzone: [2],
      weixin: [3],
      wxmoments: [4],
      weibo: [5],
      qq: [6]
    }[t] || [2, 3, 4, 5, 6];
    return this.call("setShareByBase64", {
      shareBtnList: r,
      base64: n.replace(o, "")
    });
  }, t;
}(co))(),
    Fo = {},
    Go = 1;

function Ko(e, t) {
  if (void 0 === e && (e = ""), "function" != typeof t) throw new Error("handler 参数类型不合法");
  Array.isArray(Fo[e]) || (Fo[e] = []), Fo[e].push(t);
}

function zo(e, t, n) {
  $o({
    handlerName: e,
    data: t
  }, n);
}

function $o(e, t) {
  if (t) {
    var n = "tva_" + Go + "_" + new Date().getTime();
    Go += 1, e.callbackId = n, top[n] = t;
  }

  var r = "";

  try {
    r = encodeURIComponent(JSON.stringify(e.data));
  } catch (e) {}

  var i = document.createElement("iframe");
  i.style.cssText = "display:none;width:0px;height:0px;", o.isIos && (i.onload = function () {
    t({
      errCode: -201,
      errMsg: "call bridge error"
    });
  }), i.src = "tvajsbridge://core/" + e.handlerName + "?callback=" + e.callbackId + "&params=" + r, (top.document.body || top.document.documentElement).appendChild(i), setTimeout(function () {
    i && i.parentNode && i.parentNode.removeChild(i);
  }, 500);
}

var Xo,
    Yo = {
  send: function send(e, t) {
    $o({
      data: e
    }, t);
  },
  registerHandler: Ko,
  callHandler: zo,
  on: Ko,
  invoke: zo,
  dispatchEvent: function dispatchEvent(e) {
    var t = void 0 === e ? {} : e,
        n = t.messageName,
        o = void 0 === n ? "" : n,
        r = t.messageParams,
        i = void 0 === r ? {} : r;
    Fo[o] && (Fo[o].forEach(function (e) {
      "function" == typeof e && e(i);
    }), document.querySelectorAll("iframe").forEach(function (e) {
      var t = e.contentWindow;
      if (t && t.TVAJSBridge && "function" == typeof t.TVAJSBridge.dispatchEvent && /\.qq\.com$/.test(t.location.host)) try {
        t.TVAJSBridge.dispatchEvent({
          messageName: o,
          messageParams: i
        });
      } catch (e) {
        console.error("[atom] TVAJSBridge.dispatchEvent " + e.toString());
      }
    }));
  }
},
    Zo = {
  getAppInfo: 1,
  getDeviceInfo: 1,
  getMainUserInfo: 1,
  getMainCookie: 1,
  getVideoInfo: 1,
  replayVideo: 1,
  actionLogin: 1,
  openUrl: 1,
  openWebview: 1,
  hideBackButton: 1,
  close: 1,
  closeH5: 1,
  refreshWKcookie: 1,
  publishMsgToAllWebView: 1,
  onPayFinish: 1,
  onH5LoadFinish: 1,
  setH5LayoutParams: 1,
  writeLog: 1,
  startPreview: 1,
  unlockVideo: 1,
  doH5Report: 1
},
    er = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "TVAJSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.invoke = function (e, t, n) {
    if (void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 500
    }), "function" == typeof this[e]) return this[e](t, n);
    if (!Zo[e]) throw new Wn('api "' + e + '" is not implemented', Wn.API_NOT_IMPLEMENTED);
    return this.call(e, t, n);
  }, n.call = function (e, t, n) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 500
    }), new Promise(function (o, r) {
      var i;
      console.log("[TVAJSBridge] invoke " + e + " params=", t), n.timeout > 0 && (i = setTimeout(function () {
        r(new Wn("[TVAJSBridge] invoke '" + e + "' timeout " + n.timeout + "ms", Wn.BRIDGE_INVOKE_TIMEOUT));
      }, n.timeout)), Yo.invoke(e, t || {}, function (t) {
        console.log("[TVAJSBridge] " + e + " callback=", t), i && clearTimeout(i), t && 0 === t.errCode ? o(t.result, t) : r(new Wn("[TVAJSBridge] inovke " + e + ' caught error "' + t.errMsg + "(" + t.errCode + ')"', t.errCode));
      });
    });
  }, n.on = function (e, t) {
    Yo.on(e, t);
  }, n.checkApi = function (e) {
    void 0 === e && (e = []);

    for (var t = {}, n = 0; n < e.length; n++) {
      t[e[n]] = !!Zo[e[n]];
    }

    return Promise.resolve(t);
  }, n.close = function () {
    return this.call("close");
  }, n.closeH5 = function () {
    return this.call("closeH5");
  }, n.dispatchEvent = function (e) {
    Yo.dispatchEvent(e);
  }, n.openLogin = function (e) {
    var t = this;
    return void 0 === e && (e = {
      type: ""
    }), "string" == typeof e && (e = {
      type: e
    }), this.call("actionLogin", e, {
      timeout: 3e5
    }).then(function (e) {
      return o.isQQSports && o.isIos && location.reload(), t.postMessage("onActionLoginFinish", {
        errCode: 0,
        errMsg: ""
      }), e;
    });
  }, n.switchLogin = function () {
    return o.isMqb || o.isAccomic || o.isQQSports ? this.openLogin() : this.toast("当前环境暂不支持切换账号，您可前往“我的 - 设置”切换账号");
  }, n.getAppInfo = function () {
    return this.call("getAppInfo");
  }, n.getDeviceInfo = function () {
    return this.call("getDeviceInfo");
  }, n.getMainUserInfo = function () {
    return this.call("getMainUserInfo").then(function (e) {
      return !e || ["qq", "wx"].indexOf(e.type) < 0 || !e.userInfo ? null : {
        headurl: e.userInfo.headImgUrl,
        nick: e.userInfo.nickname,
        type: e.type
      };
    });
  }, n.openUrl = function (e) {
    return e.match(/^https?:\/\//) ? navigator.userAgent.match(/TenvideoUnion\/v1\.0\.4/) ? (location.href = e, Promise.resolve()) : this.call("openUrl", {
      url: e
    }) : this.openView(e);
  }, n.openView = function (e) {
    return o.isMqb && o.isIos ? this.call("openUrl", {
      url: e
    }) : (location.href = e, Promise.resolve());
  }, n.getPayVip = function () {
    var e = ["boolean", "undefined"].includes(_typeof(arguments.length <= 0 ? void 0 : arguments[0])) ? arguments.length <= 1 ? void 0 : arguments[1] : arguments.length <= 0 ? void 0 : arguments[0];
    return Ln(e).catch(function (e) {
      return console.error(e), null;
    });
  }, n.refreshVipInfo = function () {
    return this.call("refreshVipInfo");
  }, n.postMessage = function (e, t) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), this.publishMsgToAllWebView({
      messageName: e,
      messageParams: t
    });
  }, n.publishMsgToAllWebView = function (e) {
    return void 0 === e && (e = {}), this.call("publishMsgToAllWebView", e);
  }, t;
}(co))(),
    tr = {},
    nr = n(),
    or = Array.prototype.slice,
    rr = Object.prototype.toString,
    ir = tr.__aCallbacks || {},
    ar = tr.__aReports || {},
    sr = tr.__aSupports || {},
    cr = tr.__aFunctions || {},
    ur = 1;

function lr(e, t, n) {
  var o;

  for (o in t) {
    (t.hasOwnProperty(o) && !(o in e) || n) && (e[o] = t[o]);
  }

  return e;
}

function pr(e) {
  var t = "" + ur;
  return ur += 1, e && (ir[t] = e), t;
}

function fr(e, t, n, o) {
  var r,
      i,
      a = tr.isFunction(e) ? e : ir[e] || top[e],
      s = Date.now(),
      c = (t = t || [])[0];
  tr.isUndefined(o) && (o = !0), tr.isObject(c) && ("data" in c || (c.data = lr({}, c)), "code" in c || (c.code = function (e) {
    var t,
        n,
        o,
        r = ["retCode", "retcode", "resultCode", "ret", "code", "r"];

    for (n = 0, o = r.length; n < o; n++) {
      if (r[n] in e) {
        t = e[r[n]];
        break;
      }
    }

    return t;
  }(c) || 0), c.msg = c.msg || ""), tr.isFunction(a) ? o ? setTimeout(function () {
    a.apply(null, t);
  }, 0) : a.apply(null, t) : console.log("mqqapi: not found such callback: " + e + " or the callback: " + e + " had some errors! API: " + e.name), n && (delete ir[e], delete top["__MQQ_CALLBACK_" + e]), ar[e] && (i = ar[e], delete ar[e], Number(e) && delete ar["__MQQ_CALLBACK_" + e], c && (void 0 !== c.code ? r = c.code : /^-?\d+$/.test(String(c)) && (r = c)), console.log(i.uri + "#callback", r, s - i.startTime));
}

function dr(e) {
  var t = or.call(arguments, 1);
  tr.android && t && t.length && t.forEach(function (e, n) {
    tr.isObject(e) && "r" in e && "result" in e && (t[n] = e.result);
  }), fr(e, t);
}

function hr(e, t, n, o) {
  var r,
      i = document.createElement("iframe");

  function a() {
    dr(o, {
      r: -201,
      result: "error"
    });
  }

  return i.style.cssText = "display:none;width:0px;height:0px;", tr.iOS && (i.onload = a, i.src = e), (top.document.body || top.document.documentElement).appendChild(i), tr.android && (i.onload = a, i.src = e), top.mqq && (r = top.mqq.__RETURN_VALUE, top.mqq.__RETURN_VALUE = void 0), setTimeout(function () {
    i && i.parentNode && i.parentNode.removeChild(i);
  }, 500), r;
}

function vr(e, t, n, o) {
  if (!e || !t) return null;
  var r,
      i,
      a = "__MQQ_CALLBACK_",
      s = or.call(arguments, 2);
  o = s.length && s[s.length - 1], tr.isFunction(o) || tr.isUndefined(o) ? s.pop() : o = null, s.length <= 0 && s.push({}), n = s[0];
  var c = s[s.length - 1];
  i = "string" == typeof n && 0 === n.indexOf(a) ? parseInt(s[0].replace(a, ""), 10) : tr.isObject(n) && n.callback && 0 === n.callback.indexOf(a) ? parseInt(n.callback.replace(a, ""), 10) : "string" == typeof c && 0 === c.indexOf(a) ? parseInt(c.replace(a, ""), 10) : pr(o), o && tr.isObject(n) && !n.callback && (top["__MQQ_CALLBACK_AUTO_" + i] = o, n.callback = "__MQQ_CALLBACK_AUTO_" + i), r = "jsbridge://" + encodeURIComponent(e) + "/" + encodeURIComponent(t), s.forEach(function (e, t) {
    tr.isObject(e) && (e = JSON.stringify(e)), r += 0 === t ? "?p=" : "&p" + t + "=", r += encodeURIComponent(String(e));
  }), "pbReport" !== t && (r += "#" + i);
  var u = hr(r);

  if (tr.iOS && void 0 !== u && void 0 !== u.result) {
    if (!o) return u.result;
    fr(i, [u.result]);
  }

  return null;
}

lr(tr, (Xo = {}, "Object,Function,String,Number,Boolean,Date,Undefined,Null".split(",").forEach(function (e) {
  Xo["is" + e] = function (t) {
    return rr.call(t) === "[object " + e + "]";
  };
}), Xo)), tr.iOS = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/.test(nr), tr.android = /\bAndroid([^;]+)/.test(nr), tr.iOS && tr.android && (tr.iOS = !1), tr.version = "20170222001", tr.QQVersion = "0", tr.clientVersion = "0", tr.ERROR_NO_SUCH_METHOD = "no such method", tr.ERROR_PERMISSION_DENIED = "permission denied", tr.__aCallbacks = ir, tr.__aReports = ar, tr.__aSupports = sr, tr.__aFunctions = cr, tr.__fireCallback = fr, lr(tr, {
  invoke: function invoke() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
      t[n] = arguments[n];
    }

    var o = t[0],
        r = t[1],
        i = cr[o + "." + r];
    return tr.isFunction(i) ? i.apply(this, or.call(t, 2)) : vr.apply(this, or.call(t));
  },
  callback: function callback(e, t, n) {
    if (e = tr.isFunction(e) ? e : window[e]) {
      var o = pr(e),
          r = "__MQQ_CALLBACK_" + o;
      return window[r] = function () {
        var e = or.call(arguments);
        fr(o, e, t, n);
      }, r;
    }
  },
  execGlobalCallback: dr,
  on: function on(e, t) {
    if ("qbrowserVisibilityChange" === e) return document.addEventListener(e, t, !1), !0;
    var n = "evt-" + e;
    return (ir[n] = ir[n] || []).push(t), !0;
  },
  off: function off(e, t) {
    var n,
        o = "evt-" + e,
        r = ir[o],
        i = !1;
    if (!r) return !1;
    if (!t) return delete ir[o], !0;

    for (n = r.length - 1; n >= 0; n--) {
      t === r[n] && (r.splice(n, 1), i = !0);
    }

    return i;
  },
  dispatchEvent: function dispatchEvent(e, t, n) {
    var o = {
      event: e,
      data: t || {},
      options: n || {}
    };
    hr("jsbridge://event/dispatchEvent?p=" + encodeURIComponent(JSON.stringify(o) || ""));
  },
  execEventCallback: function execEventCallback(e) {
    var t = arguments,
        n = "evt-" + e,
        o = ir[n],
        r = or.call(arguments, 1);
    o && o.forEach(function (e) {
      fr(e, r, !1);
    });
    var i = document.querySelectorAll("iframe");
    i.forEach(function (e) {
      var n = e.contentWindow;
      if (n && n.mqq && "function" == typeof n.mqq.execEventCallback && /\.qq\.com$/.test(n.location.host)) try {
        var o;
        (o = n.mqq).execEventCallback.apply(o, t);
      } catch (e) {
        console.error("[atom] WeishiBridge.dispatchEvent " + e.toString());
      }
    });
  }
}, !0), o.isWeishi && (e.mqq = tr);
var gr = {
  getAppInfo: 1,
  getDeviceInfo: 1,
  getMainUserInfo: 1,
  getVideoInfo: 1,
  replayVideo: 1,
  actionLogin: 1,
  openWebview: 1,
  close: 1,
  closeH5: 1,
  refreshWKcookie: 1,
  publishMsgToAllWebView: 1,
  onPayFinish: 1
},
    mr = ["appid", "openid", "accessToken", "refreshToken", "iAuthType", "sUid", "sSessionKey", "vqq_appid", "vqq_access_token", "vqq_vuserid", "vqq_vusession", "vqq_openid"],
    yr = {
  domain: "qq.com",
  path: "/"
},
    wr = 1;
e.pageStateCallback || (e.pageStateCallback = function (e) {
  if (e && e.data) {
    var t = "onResume" === e.data.function ? "onPageAppear" : "onPageDisappear";
    tr.execEventCallback(t);
  }
});

var br,
    _r = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "WeishiJSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.invoke = function (e, t, n) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 5e3
    }), "function" == typeof this[e] ? this[e](t, n) : this.call(e, t, n);
  }, n.call = function (e, t, n) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {
      timeout: 5e3
    }), new Promise(function (o, r) {
      var i,
          a = e.match(/^([a-z]+)\.([a-z]+)?/i) || ["", "tenvideo", e],
          s = a[1],
          c = a[2];
      console.log("[WeishiJSBridge] invoke " + s + "." + c + " params=", t), n.timeout > 0 && (i = setTimeout(function () {
        r(new Wn("[WeishiBridge] invoke '" + c + "' timeout " + n.timeout + "ms"));
      }, n.timeout)), tr.invoke(s, c, t || {}, function (e) {
        console.log("[WeishiJSBridge] " + c + " callback=", e), i && clearTimeout(i), e && 0 === parseInt(e.code, 10) ? o(e.data, e) : r(new Wn("[WeishiJSBridge] inovke " + c + ' caught error "' + e.msg + "(" + e.code + ')"', e.code));
      });
    });
  }, n.on = function (e, t) {
    o.isAndroid && this.call("event.addEventListener", {
      event: e
    }, {
      timeout: 0
    }).then(t), tr.on(e, t);
  }, n.checkApi = function (e) {
    void 0 === e && (e = []);

    for (var t = {}, n = 0; n < e.length; n++) {
      t[e[n]] = !!gr[e[n]];
    }

    return Promise.resolve(t);
  }, n.closeH5 = function () {
    return this.close();
  }, n.dispatchEvent = function (e) {
    tr.dispatchEvent(e);
  }, n.openLogin = function () {
    var e = c(f.mark(function e() {
      var t, n;
      return f.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = {
                doLogin: !0
              }, o.isTenvideoUnion && (t.source = "tenvideo"), e.next = 4, this.call("weishi.login", t, {
                timeout: 3e5
              });

            case 4:
              if (n = e.sent, !this.needAuthOnly()) {
                e.next = 11;
                break;
              }

              return e.next = 8, this.call("refreshWKcookie");

            case 8:
              if (!["vuserid", "vusession"].map(function (e) {
                var t = n.iAuthType === wr ? "vqq_" : "";
                return L.get(t + e);
              }).some(function (e) {
                return "" === e;
              })) {
                e.next = 11;
                break;
              }

              throw new Wn("[weishi.openLogin]Authorization is cancelled", Wn.LOGIC_ERROR);

            case 11:
              return this.postMessage("onActionLoginFinish", {
                errCode: 0,
                errMsg: ""
              }, {
                echo: !0
              }), e.abrupt("return", n);

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(), n.needAuthOnly = function () {
    if (o.isIos && !so.compare(o.appVersion, "8.25")) return !1;
    var e = L.get("main_login");
    if (!e) return !1;
    var t = "qq" === e ? "vqq_" : "";
    return !!["appid", "openid", "access_token"].map(function (e) {
      return L.get(t + e);
    }).every(function (e) {
      return "" !== e;
    }) && ["vuserid", "vusession"].map(function (e) {
      return L.get(t + e);
    }).some(function (e) {
      return "" === e;
    });
  }, n.switchLogin = function () {
    var e = c(f.mark(function e(t) {
      return f.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return void 0 === t && (t = ""), e.next = 3, this.logout();

            case 3:
              return e.abrupt("return", this.openLogin({
                type: t
              }));

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(), n.logout = function () {
    var e = c(f.mark(function e() {
      var t;
      return f.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.call("weishi.logout");

            case 2:
              if (t = e.sent, !o.isAndroid) {
                e.next = 6;
                break;
              }

              return e.next = 6, Qn(100);

            case 6:
              return mr.forEach(function (e) {
                return L.remove(e, yr);
              }), e.abrupt("return", t);

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(), n.getAppInfo = function () {
    return this.call("getAppInfo");
  }, n.getDeviceInfo = function () {
    return this.call("device.getDeviceInfo").then(function (e) {
      return e && (e.isJBOS = e.isRoot), e;
    });
  }, n.getMainUserInfo = function () {
    return o.isTenvideoUnion ? this.call("getMainUserInfo").then(function (e) {
      return !e || !e.userInfo || "qq" !== e.type && "wx" !== e.type ? null : {
        headurl: e.userInfo.headImgUrl,
        nick: e.userInfo.nickname,
        type: e.type
      };
    }) : e.prototype.getMainUserInfo.call(this, !0);
  }, n.openUrl = function (e) {
    return e.match(/^weishi:\/\//) ? this.openView(e) : this.openView("weishi://webview?jump_url=" + encodeURIComponent(e));
  }, n.openView = function (e) {
    return this.call("weishi.openScheme", {
      scheme: e
    });
  }, n.getPayVip = function (e) {
    return void 0 === e && (e = {}), Ln(e).catch(function (e) {
      return console.error(e), null;
    });
  }, n.refreshVipInfo = function () {
    if (!o.isTenvideoUnion) throw new Wn('"refreshVipInfo" is not supported in this version!');
    return this.call("refreshVipInfo");
  }, n.close = function () {
    return this.call("ui.popBack");
  }, n.saveImage = function (e) {
    return e && e.match(/^https?:\/\//) ? Promise.reject(new Error("当前环境仅支持使用base64保存")) : this.call("media.saveImage", {
      content: e
    });
  }, n.postMessage = function (e, t, n) {
    return void 0 === e && (e = ""), void 0 === t && (t = {}), void 0 === n && (n = {}), this.publishMsgToAllWebView({
      messageName: e,
      messageParams: t
    }, n);
  }, n.publishMsgToAllWebView = function (e, t) {
    var n = void 0 === e ? {} : e,
        o = n.messageName,
        r = void 0 === o ? "" : o,
        i = n.messageParams,
        a = void 0 === i ? {} : i;
    return void 0 === t && (t = {}), tr.dispatchEvent(r, a, P({
      echo: !1,
      broadcast: !0,
      domains: ["*.qq.com"]
    }, t)), Promise.resolve({
      errCode: 0,
      errMsg: ""
    });
  }, t;
}(co))(),
    Or = ["id", "price", "product_type", "amount"],
    xr = new (function (e) {
  function t() {
    var t;
    return (t = e.call(this) || this).name = "WetvJSBridge", t;
  }

  s(t, e);
  var n = t.prototype;
  return n.logout = function () {
    return $n("logout", {
      needBack: !1
    });
  }, n.openPay = function (e) {
    void 0 === e && (e = {});
    var t = e,
        n = t.id,
        o = t.price,
        r = t.product_type,
        i = t.amount,
        a = q(t, Or);
    if (!n) throw {
      errCode: -10,
      errMsg: "[atom.openPay]miss required option(options.id)"
    };
    return Bn(a, {
      product_price: o,
      productprice: o,
      id: n,
      productid: n,
      product_type: "month",
      month: i
    }), "serial" === r && (a.serialpay = 1), $n("openPay", a);
  }, t;
}(co))();

if (o.isWeishi) br = _r;else if (o.isTenvideoUnion) br = er, e.TVAJSBridge = er;else if (o.isQQSports) br = Ho;else if (o.isQQMusic) br = Wo;else if (o.isApp) {
  if (o.isWetv) br = xr;else if (o.isKidApp) br = So;else switch (o.device) {
    case "mac":
      br = ko;
      break;

    case "windows":
      br = Io;
      break;

    case "ipad":
    case "apad":
      br = po;
      break;

    default:
      br = Bo;
  }
} else br = uo;
o.isBaseApp && ao().compare("8.2.5") && (br = Bo), console && console.log("[atom] Using " + br.name + "!");
var Er = br;
export default Er;